// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:39:55.617Z
// Property: 97 @ North Oak (ID: 6767906449165581)
// Collections: 35 amenities, 9 floorplans (live), 59 photos, 59 POIs, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165581",
  "property_external_id": "nw039sq",
  "property_zillow_url": "https://www.zillow.com/apartments/kansas-city-mo/97-@-north-oak/CkBhWB/",
  "property_apartments_url": "https://www.apartments.com/97-north-oak-kansas-city-mo/nw039sq/",
  "property_google_business_url": "https://www.google.com/maps/place/97@+North+Oak+Apartments/data=!4m2!3m1!1s0x0:0x8fa38424b2a3cf30?sa=X&ved=2ahUKEwiG2cWx8LySAxWJkIkEHUf_DYQQ_BJ6BAhDEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "97-@-north-oak",
  "property_name": "97 @ North Oak",
  "property_website_url": "https://www.caseusa.com/apartments/mo/kansas-city/97-north-oak/",
  "property_domain": null,
  "property_address": "97 NE 97th St.",
  "property_full_address": "97 NE 97th St., Kansas City, MO, 64155",
  "property_address_1": "97 NE 97th St.",
  "property_address_2": null,
  "property_address_city": "Kansas City",
  "property_address_state": "MO",
  "property_address_zip_full": null,
  "property_address_zip": "64155",
  "property_address_country": "US",
  "property_address_county": "Clay County",
  "property_neighborhood_address": "Meadowbrook Heights",
  "property_address_latitude": "39.2701",
  "property_address_longitude": "-94.5774",
  "property_email": "97northoak@caseusa.com",
  "property_phone": "(816) 281-9866",
  "property_call_tracking_phone": "866-761-2177",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Nestled in the heart of Kansas City, 97 at North Oak offers a vibrant blend of style and comfort. Choose from spacious one, two, or three-bedroom apartments, each featuring modern amenities like stainless steel appliances and walk-in closets. Enjoy our inviting pool, fitness center, and pet-friendly spaces. Your ideal lifestyle awaits! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to 97 at North Oak, your ideal apartment community nestled in the heart of Kansas City, Missouri. Our spacious floor plans boast one, two, and three-bedroom layouts designed to fit your lifestyle perfectly. Whether you're looking for a cozy retreat or a family-friendly space, we have the right apartment for you.\n\nAt 97 at North Oak, we prioritize your comfort and convenience with a suite of premium amenities. Dive into relaxation at our refreshing pool, work up a sweat in our state-of-the-art fitness center, or unwind in our stylish clubhouse. Families will appreciate our playground and picnic area, while pet owners will love the dedicated pet play area and washing station. Enjoy seamless online services alongside 24-hour access and on-site maintenance for stress-free living.\n\nOur well-appointed apartments feature modern touches such as stainless steel appliances, high ceilings, and walk-in closets. Each home is equipped with essential amenities including air conditioning, heating, and high-speed internet access. Choose your perfect space with options for a balcony or patio to enjoy the outdoors right at home.\n\nLocated in a vibrant neighborhood, 97 at North Oak offers a gated community with unparalleled access to local attractions and conveniences. Experience the best of apartment living with services like concierge support, package service, and health club discounts.\n\nFind your new home today—browse our availability or schedule a tour to experience our exceptional community firsthand! Your journey to upscale living begins here at 97 at North Oak.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019dbbe7-648c-774a-a48f-f734385e4e24.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and cabanas at a modern apartment complex.",
    "public_id": "019dbbe7-648c-774a-a48f-f734385e4e24",
    "storage_key": "property/6767906449165581/019dbbe7-648c-774a-a48f-f734385e4e24.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "317",
  "property_year_built": "2021",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.26813880126183",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "175",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum of two pets per unit. No weight limit. Breed restrictions apply.",
  "property_pet_policy_description": "No weight limit. Maximum of two pets. Breed restrictions apply. Pet rent: $30 per pet per month. $500 fee per pet (non‑refundable). Service animals are not considered pets; pet fees and pet rent do not apply to service animals.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://97atnorthoakkansascity.securecafe.com/onlineleasing/97-north-oak/floorplans.aspx",
  "property_resident_portal_url": "https://97atnorthoakkansascity.securecafe.com/residentservices/97-north-oak/userlogin.aspx",
  "property_apply_now_url": "https://97atnorthoakkansascity.securecafe.com/onlineleasing/97-north-oak/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb38-cbf6-730b-aee2-3e765f6b8f96.webp",
  "property_primary_logo_media": {
    "alt_text": "Ninety-Seven at North Oak Apartments logo",
    "public_id": "019cfb38-cbf6-730b-aee2-3e765f6b8f96",
    "storage_key": "property/6767906449165581/019cfb38-cbf6-730b-aee2-3e765f6b8f96.webp",
    "width": 355,
    "height": 120
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb38-bada-73ec-be1d-075ad67bf598.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb38-bada-73ec-be1d-075ad67bf598",
    "storage_key": "property/6767906449165581/019cfb38-bada-73ec-be1d-075ad67bf598.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb38-db6b-757d-a149-c234ec15d492.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Ninety-Seven @ North Oak Apartments logo",
    "public_id": "019cfb38-db6b-757d-a149-c234ec15d492",
    "storage_key": "property/6767906449165581/019cfb38-db6b-757d-a149-c234ec15d492.webp",
    "width": 355,
    "height": 120
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb38-e40b-7588-9c91-9302494a55e0.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Ninety-Seven at North Oak Apartments logo",
    "public_id": "019cfb38-e40b-7588-9c91-9302494a55e0",
    "storage_key": "property/6767906449165581/019cfb38-e40b-7588-9c91-9302494a55e0.webp",
    "width": 355,
    "height": 120
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#00adbb",
  "property_secondary_color": "#59595c",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1108",
  "property_sqft_min": "789",
  "property_sqft_max": "1108",
  "property_price_range": "1360 - 1789",
  "property_price_min": "1360",
  "property_price_max": "1789",
  "property_available_units": 15,
  "property_facebook_url": "https://www.facebook.com/97atNorthOak/photos/d41d8cd9/683073387267817/",
  "property_instagram_url": "https://www.instagram.com/97atnorthoak/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ0ygC-NNZwIcRMM-jsiSEo48",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/97-north-oak-apartments-kansas-city",
  "property_tiktok_url": "https://www.tiktok.com/@97northoakkc",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to 97 at North Oak",
  "property_home_romance_title": "Live Your Best Life in a Loving Apartment Community",
  "property_home_amenities_blurb": "Welcome to 97 at North Oak in vibrant Kansas City, where modern living meets comfort. Choose from stylish one, two, or three-bedroom apartments, each crafted with premium amenities. Enjoy lounging by the pool, breaking a sweat in the fitness center, or relaxing on your private patio. Experience community like never before! ",
  "property_home_floorplans_blurb": "Welcome to 97 at North Oak in vibrant Kansas City, Missouri, where stylish living meets comfort. Choose from our thoughtfully designed one, two, or three-bedroom floor plans, each tailored to enhance your lifestyle. Browse through our available apartment homes and find your ideal space today!",
  "property_home_gallery_blurb": "At 97 at North Oak in Kansas City, modern living unfolds with thoughtfully designed one to three-bedroom floor plans. Embrace convenience with our premier amenities, including a sparkling pool, fitness center, and pet-friendly areas. Picture yourself basking on the sundeck or enjoying the vibrant clubhouse atmosphere!",
  "property_home_neighborhood_blurb": "Welcome to 97 at North Oak, where vibrant living meets convenience in Kansas City! Nestled near parks, libraries, and the Springs Aquatic Center, our community offers one, two, and three-bedroom floor plans tailored for your lifestyle. Uncover local spots like the Shoal Creek Golf Course and discover your ideal home today!",
  "property_home_reviews_blurb": "Welcome to 97 at North Oak, where spacious living and quick maintenance blend seamlessly. Our residents rave about \"excellent apartments and management\" in a \"quiet environment.\" Enjoy convenient access to amenities and a vibrant community. Curious about what makes our home special? See what our residents have to say!",
  "property_neighborhood_blurb": "At 97 at North Oak, Kansas City, you’re surrounded by vibrant living. Unwind outdoors at Happy Rock Park, indulge in history at the Shoal Creek Living History Museum, or enjoy active days at the Springs Aquatic Center. Adventure awaits just steps from your doorstep—curate your perfect neighborhood experience.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At 97 at North Oak in Kansas City, experience a lifestyle that balances comfort with vibrancy. Enjoy spacious one to three-bedroom floor plans adorned with stainless steel appliances, walk-in closets, and private balconies. Our premium amenities, including a resort-style pool, fitness center, and pet-friendly areas, await your exploration!",
  "property_applynow_blurb": "At 97 at North Oak in vibrant Kansas City, your perfect home awaits with spacious one, two, and three-bedroom floor plans. Enjoy resort-style amenities, from a rejuvenating pool and state-of-the-art fitness center to a tranquil pet playground. Embrace convenient living—apply online today and start your next chapter!",
  "property_contactus_blurb": "At 97 at North Oak in Kansas City, Missouri, your dream home awaits! Offering spacious one, two, and three-bedroom layouts, each floor plan is designed for comfort and style. Have questions? Our dedicated leasing team is ready to assist you in finding the perfect space. Reach out to us today!",
  "property_faqs_blurb": "At 97 at North Oak in vibrant Kansas City, Missouri, our diverse floor plans—ranging from cozy one-bedroom retreats to spacious three-bedroom homes—are designed to cater to every lifestyle. Visit our FAQs page and delve into answers that illuminate your living experience with us! ",
  "property_floorplans_blurb": "At 97 at North Oak in Kansas City, Missouri, we offer thoughtfully designed one, two, and three-bedroom apartment homes that harmonize style and comfort. Each layout captures the essence of modern living. Browse our available floor plans and envision your ideal space today!",
  "property_gallery_blurb": "At 97 at North Oak in Kansas City, vibrant living meets modern luxury. Enjoy spacious floor plans, from cozy one bedrooms to expansive three bedrooms. Relax by the sparkling pool, stay active in the fitness center, or unwind in the thoughtfully designed outdoor spaces. Picture yourself living here!",
  "property_interactivemap_blurb": "Welcome to 97 at North Oak in Kansas City, where modern living meets ultimate convenience. Choose from spacious one, two, or three-bedroom layouts with stunning amenities, including a refreshing pool, state-of-the-art fitness center, and pet-friendly spaces. Use our interactive community map for an effortless apartment search!",
  "property_pets_blurb": "Welcome to 97 at North Oak in vibrant Kansas City! Our community embraces your furry friends, allowing up to two pets per unit with a focus on compatibility. Enjoy pet-friendly living that complements your lifestyle, all within the heart of the city’s best amenities. Join us and make home truly whole!",
  "property_referafriend_blurb": "At 97 at North Oak in Kansas City, our vibrant community offers spacious one, two, and three-bedroom floor plans designed for modern living. With great friends making the best neighbors, why not share the love? Refer a friend and help them find their perfect home today!",
  "property_residentaccess_blurb": "At 97 at North Oak in Kansas City, find the perfect space for your lifestyle with our diverse floor plans—choose from stylish one, two, or three-bedroom apartments. Access your resident portal effortlessly to pay rent, schedule maintenance, and enhance your living experience today!",
  "property_reviews_blurb": "Experience the charm of 97 at North Oak in Kansas City, where spacious apartments and a friendly management team create a welcoming community. Residents rave about the professional staff and prompt maintenance, ensuring your comfort and peace of mind. “Overall, a great place to live!” Join us today!",
  "property_created_at": "1753982376261",
  "property_scheduletour_blurb": "At 97 at North Oak in Kansas City, Missouri, our thoughtfully designed floor plans—ranging from one to three bedrooms—offer the perfect blend of comfort and style. Experience the vibrant community atmosphere, and don’t just take our word for it; hear from our residents about their home sweet home! Schedule a tour today!",
  "property_thankyou_blurb": "Thank you for your interest in 97 at North Oak in vibrant Kansas City! With spacious one, two, and three-bedroom floor plans, we’re excited to help you find your perfect home. A member of our team will be in touch soon to answer your questions and guide you through the next steps.",
  "property_virtualtours_blurb": "At 97 at North Oak, our diverse floor plans—from cozy one-bedrooms to spacious three-bedrooms—cater to every lifestyle. Nestled in vibrant Kansas City, our community offers a seamless blend of comfort and elegance. Take a virtual tour today and envision your ideal apartment home!",
  "property_copyright": "2025 All Rights Reserved. 97 at North Oak",
  "property_seo_title_home": "97 at North Oak |  Apartments in Kansas City, Missouri",
  "property_seo_description_home": "Experience comfort and style at 97 at North Oak! With stunning floor plans and top-notch amenities, your perfect Kansas City home awaits. Act now!",
  "property_seo_title_floorplans": "Floor Plans | Kansas City, Missouri Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at 97 at North Oak in Kansas City! Choose from stylish one, two, and three-bedroom floor plans tailored to your lifestyle.",
  "property_seo_title_amenities": "Amenities | Kansas City, Missouri Apartments for Rent",
  "property_seo_description_amenities": "Experience vibrant living at 97 at North Oak! Enjoy a sparkling pool and state-of-the-art fitness center tailored to your lifestyle in Kansas City.",
  "property_seo_title_gallery": "Gallery | Apartments in Kansas City, Missouri",
  "property_seo_description_gallery": "Discover your dream lifestyle at 97 at North Oak! Enjoy stunning floor plans and top-notch amenities in vibrant Kansas City.",
  "property_seo_title_virtualtours": "Virtual Tours | 97 at North Oak Apartments",
  "property_seo_description_virtualtours": "Experience the charm of 97 at North Oak in Kansas City! Take a virtual tour of our stunning one, two, and three-bedroom apartments designed for modern living.",
  "property_seo_title_interactivemap": "Interactive Map | 97 at North Oak Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at 97 at North Oak in Kansas City! Use our interactive map to explore vibrant apartments with top amenities—your perfect space awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Kansas City, Missouri",
  "property_seo_description_neighborhood": "Experience Kansas City living at 97 at North Oak! Uncover local gems and vibrant spots just steps from home. Your new adventure awaits!",
  "property_seo_title_contact": "Contact Us | 97 at North Oak",
  "property_seo_description_contact": "Reach out to 97 at North Oak in Kansas City! Our friendly leasing team is ready to answer your questions about our one to three-bedroom floor plans.",
  "property_seo_title_faqs": "FAQs | Apartments in Kansas City, Missouri",
  "property_seo_description_faqs": "Find the answers you need about 97 at North Oak in Kansas City! From amenities to floor plans, our FAQ page has it all. Explore your future home today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Kansas City, Missouri",
  "property_seo_description_reviews": "Join the vibrant community at 97 at North Oak! Check out resident reviews and see why our amenities and floor plans make living in Kansas City exceptional!",
  "property_seo_title_applynow": "Apply Now | Apartments in Kansas City, Missouri",
  "property_seo_description_applynow": "Find your perfect home at 97 at North Oak in Kansas City! Enjoy luxury amenities, spacious floor plans, and easy online leasing. Your new life awaits!",
  "property_seo_title_residentaccess": "Resident Access | 97 at North Oak",
  "property_seo_description_residentaccess": "Experience convenient resident life at 97 at North Oak! Log in to pay rent, manage requests, and access community updates effortlessly.",
  "property_seo_title_referafriend": "Refer A Friend | 97 at North Oak",
  "property_seo_description_referafriend": "Share the love at 97 at North Oak! Refer a friend and enjoy exclusive perks in our vibrant Kansas City community. Great friends make great neighbors!",
  "property_seo_title_scheduletour": "Schedule a Tour | 97 at North Oak",
  "property_seo_description_scheduletour": "Experience upscale living at 97 at North Oak in Kansas City! Schedule your tour today and see why our community is the perfect place to call home.",
  "property_seo_title_privacy": "Privacy Policy | 97 at North Oak",
  "property_seo_description_privacy": "At 97 at North Oak in Kansas City, we prioritize your privacy. Learn how we protect your information in our comprehensive privacy policy. View it now!",
  "property_seo_title_accessibility": "Website Accessibility | 97 at North Oak",
  "property_seo_description_accessibility": "At 97 at North Oak in Kansas City, we champion digital inclusion. Learn how our community ensures accessibility for everyone, making home a welcoming space.",
  "property_seo_title_sitemap": "Sitemap | 97 at North Oak",
  "property_seo_description_sitemap": "Navigate your future home at 97 at North Oak in Kansas City! Check out our sitemap for an easy guide to amenities, floor plans, and everything we offer.",
  "property_seo_title_thankyou": "Thank You | 97 at North Oak",
  "property_seo_description_thankyou": "Thank you for reaching out to 97 at North Oak! Our team in Kansas City is eager to connect and help you find your ideal apartment home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Kansas City, Missouri",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787864655790",
  "amenities": [
    {
      "id": "ec_caeadedd408b54d919fcd753",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127396149",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51a4c6168264f5ec4b1bce06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127396150",
      "title": "Online Rental Payment",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a33692a572628faf5b5098a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127396151",
      "title": "On-Site Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b953a88f1c2ab3f0628ea6b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127396152",
      "title": "Internet Cafe w/ Complimentary Gourmet Coffee & Tea",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13589f5c1352459273ebe5bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127396153",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e38b12c133f94802fe13a57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127396154",
      "title": "Relaxing Clubhouse w/ Billiards & Shuffleboard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d34e679ef7bae77910c2d938",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127396155",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee47eab78a8da7170c8fe4c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127396156",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c67df246a57193b7f50f697",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127396157",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_add0111b518444fbedc38fa5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127396158",
      "title": "Gated Electronic Entrance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_95d4edfc252e53485ccbbff3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127396159",
      "title": "24-Hour, On-Trend Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76eabbd7fc6292ee2279a69d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127396160",
      "title": "Resort-Worthy Swimming Pool w/Sundeck & Cabana Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ae5c33eece562464f5e3342a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127396161",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0e49d64721931a889cf5a847",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127396162",
      "title": "Lush Courtyards w/ Pet Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7843a9955441f4fb1ea3a9a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127396163",
      "title": "Secure Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ab1bb16d61f648a6dc682df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397658",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33eb897eb8ff47d0d1de2948",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397659",
      "title": "Handrails",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2113a2d92cdc22014a146fd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397660",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_12026fcfc521d7d65c2cf8bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397661",
      "title": "White Subway Tile Backsplash in Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_86dcb7a1992753991bc4108d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397662",
      "title": "Dove Grey or Espresso Cabinets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a555a1bf25b5f579fcfe24de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397663",
      "title": "Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ee1ca7cb0d88b695ddfeb6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397665",
      "title": "1, 2 & 3 Bedroom Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_198ca6ff2143739e6cead937",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397666",
      "title": "Side-by-Side Refrigerator w/Ice Maker & Filtered Water",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af9baaecfb919ad9358b29db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397667",
      "title": "Dishwasher, Microwave & Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c77aba37bf6146550cb1f9fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397668",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14a5741057adba8d479dd818",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397669",
      "title": "Private Patio or Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_70ef90c7eb759606068f03a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397670",
      "title": "Modern LED Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8dfa213716c1b8d2a0c9e7f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397671",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_964ce3732919c8ffae352ab4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397672",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5d82c0eb9a068fe28bcbabd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397673",
      "title": "Oversized & Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc15b9bbc57261db16400b56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397674",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c59667782d52d9b3ed8d91dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397675",
      "title": "Central Heat & Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed6433b7876679697e0646f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397676",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba28b359c98122ac641796ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397677",
      "title": "Stylish Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82fcd4f3c42e1ef6a33f565f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "yardi",
      "external_id": "127397678",
      "title": "Accessible*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_42f26630-bf6f-459f-8224-f1616d2d8d52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-c875-75af-8dc5-1f3d478293b0.webp",
      "image_media": {
        "alt_text": "A tastefully decorated bedroom with a queen-sized bed, dresser, and nightstand.",
        "public_id": "019db72a-c875-75af-8dc5-1f3d478293b0",
        "storage_key": "property/6767906449165581/019db72a-c875-75af-8dc5-1f3d478293b0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This bedroom features a comfortable queen-sized bed with plush bedding, a spacious dresser for storage, and a stylish nightstand with a lamp.",
      "link": "",
      "alt_text": "A tastefully decorated bedroom with a queen-sized bed, dresser, and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0598e890-cc3a-434a-87b5-75c7c680dbef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-c7a1-7139-acf1-f677933a05d2.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with marble countertop, sink, faucet, mirror, and decorative items.",
        "public_id": "019db72a-c7a1-7139-acf1-f677933a05d2",
        "storage_key": "property/6767906449165581/019db72a-c7a1-7139-acf1-f677933a05d2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Elegant bathroom vanity featuring a marble countertop, a sleek sink, and modern fixtures. Decorated with pampas grass and candles, this space offers a touch of luxury.",
      "link": "",
      "alt_text": "Bathroom vanity with marble countertop, sink, faucet, mirror, and decorative items.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f0d41d26-abd3-4e43-8eb3-acd3fdd58f0b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-bfde-7716-9867-60131451596f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white tub, shower curtain, toilet, and vanity with a marble countertop.",
        "public_id": "019db72a-bfde-7716-9867-60131451596f",
        "storage_key": "property/6767906449165581/019db72a-bfde-7716-9867-60131451596f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom, featuring a sleek vanity with a marble countertop, a clean white tub, and decorative accents.",
      "link": "",
      "alt_text": "Modern bathroom with a white tub, shower curtain, toilet, and vanity with a marble countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6a572612-05bb-465a-b33d-58e347781ce4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-a0e4-739f-955e-88a7fc8f02b5.webp",
      "image_media": {
        "alt_text": "Modern dark wood U-shaped kitchen with stainless steel appliances, white subway tile backsplash, and marble countertops.",
        "public_id": "019db72a-a0e4-739f-955e-88a7fc8f02b5",
        "storage_key": "property/6767906449165581/019db72a-a0e4-739f-955e-88a7fc8f02b5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover your culinary haven in this beautifully designed U-shaped kitchen, featuring sleek dark wood cabinetry, modern stainless steel appliances, and elegant marble countertops.",
      "link": "",
      "alt_text": "Modern dark wood U-shaped kitchen with stainless steel appliances, white subway tile backsplash, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_58e0dedf-13f6-48fa-a51c-96f27911ed24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-a6c9-7287-aaa5-ed2fab83ff54.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with marble countertop and dark wood cabinets.",
        "public_id": "019db72a-a6c9-7287-aaa5-ed2fab83ff54",
        "storage_key": "property/6767906449165581/019db72a-a6c9-7287-aaa5-ed2fab83ff54.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a marble-look vanity, ample storage, and elegant decor.",
      "link": "",
      "alt_text": "Modern bathroom vanity with marble countertop and dark wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e0ee2d0e-c5a3-4916-a114-47593d16cc30",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-9ea0-7371-b9dc-d47d1195764b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and dark cabinets.",
        "public_id": "019db72a-9ea0-7371-b9dc-d47d1195764b",
        "storage_key": "property/6767906449165581/019db72a-9ea0-7371-b9dc-d47d1195764b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and elegant marble countertops.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and dark cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_95fb6eda-6dfe-4c9f-a11c-349831670d06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-9dbc-7719-9e88-ebfdfac92f4d.webp",
      "image_media": {
        "alt_text": "Dining area and home office space with desk, chair, and large artwork.",
        "public_id": "019db72a-9dbc-7719-9e88-ebfdfac92f4d",
        "storage_key": "property/6767906449165581/019db72a-9dbc-7719-9e88-ebfdfac92f4d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This versatile space offers a dedicated home office area, perfect for remote work, alongside a charming dining nook for meals.",
      "link": "",
      "alt_text": "Dining area and home office space with desk, chair, and large artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2a24e337-3493-4459-a531-145bd8021794",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-9624-713e-8985-c8014c06fff4.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sofa, armchair, coffee table, and desk by the window.",
        "public_id": "019db72a-9624-713e-8985-c8014c06fff4",
        "storage_key": "property/6767906449165581/019db72a-9624-713e-8985-c8014c06fff4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully furnished living room, featuring ample natural light and a dedicated workspace.",
      "link": "",
      "alt_text": "Spacious living room with a sofa, armchair, coffee table, and desk by the window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c2bc3894-a1d7-42c5-88d5-c9cb28484522",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-9ed7-7361-a967-fedb93481b86.webp",
      "image_media": {
        "alt_text": "Dining room with a round table and four chairs, featuring blue curtains and a view of the exterior buildings.",
        "public_id": "019db72a-9ed7-7361-a967-fedb93481b86",
        "storage_key": "property/6767906449165581/019db72a-9ed7-7361-a967-fedb93481b86.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable dining in this well-appointed apartment, complete with a stylish round table and chairs, elegant blue drapery, and scenic views.",
      "link": "",
      "alt_text": "Dining room with a round table and four chairs, featuring blue curtains and a view of the exterior buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e657dcca-96cc-477a-9db6-575ab77eb6f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-9fb2-733d-8aa6-1c8d590c772b.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, TV, and open doorway to bedroom.",
        "public_id": "019db72a-9fb2-733d-8aa6-1c8d590c772b",
        "storage_key": "property/6767906449165581/019db72a-9fb2-733d-8aa6-1c8d590c772b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a modern fireplace and television, with a glimpse into a comfortable bedroom.",
      "link": "",
      "alt_text": "Living room with fireplace, TV, and open doorway to bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cfa161b9-d67d-43c0-b3eb-14aa3a2bb5ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-a20d-74dd-9eee-011b302ab220.webp",
      "image_media": {
        "alt_text": "Bathroom with a shower curtain, toilet, and vanity with a marble countertop.",
        "public_id": "019db72a-a20d-74dd-9eee-011b302ab220",
        "storage_key": "property/6767906449165581/019db72a-a20d-74dd-9eee-011b302ab220.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the modern comforts of this apartment bathroom, featuring a stylish shower curtain, a clean toilet, and a spacious vanity with a marble countertop.",
      "link": "",
      "alt_text": "Bathroom with a shower curtain, toilet, and vanity with a marble countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2a1025af-8488-4fa4-8abb-b803fa465d9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-9d91-7737-b31e-4bcf15e1adcf.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving and decorative baskets on the floor.",
        "public_id": "019db72a-9d91-7737-b31e-4bcf15e1adcf",
        "storage_key": "property/6767906449165581/019db72a-9d91-7737-b31e-4bcf15e1adcf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample wire shelving for storage and decorative baskets to add a touch of style. Perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving and decorative baskets on the floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1a30b0db-cdb6-46ca-824d-0ad999362dab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-79c1-73bc-83a7-9ac7d7a7099b.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstand, dresser, and ceiling fan.",
        "public_id": "019db72a-79c1-73bc-83a7-9ac7d7a7099b",
        "storage_key": "property/6767906449165581/019db72a-79c1-73bc-83a7-9ac7d7a7099b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed, elegant nightstand with lamp, and a large dresser. The room is enhanced by a ceiling fan and a large window.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstand, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a3e38c1c-0c69-451d-9826-6ebc719d6a31",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-7c46-7605-bcbf-7b0e30457c7b.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with stylish furniture and modern appliances.",
        "public_id": "019db72a-7c46-7605-bcbf-7b0e30457c7b",
        "storage_key": "property/6767906449165581/019db72a-7c46-7605-bcbf-7b0e30457c7b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sofa and accent chairs, seamlessly flowing into a modern kitchen with a breakfast bar and stainless steel appliances.",
      "link": "",
      "alt_text": "Living room and kitchen area with stylish furniture and modern appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f481fe3-ad7c-4cf5-9bee-49006edd3198",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-7988-73bd-b6ed-85ad739d50df.webp",
      "image_media": {
        "alt_text": "View from a balcony showing a resort-style pool and modern apartment buildings.",
        "public_id": "019db72a-7988-73bd-b6ed-85ad739d50df",
        "storage_key": "property/6767906449165581/019db72a-7988-73bd-b6ed-85ad739d50df.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the resort-style pool and outdoor amenities from your private balcony, overlooking the modern apartment buildings and lush landscaping.",
      "link": "",
      "alt_text": "View from a balcony showing a resort-style pool and modern apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8489dffe-e5ef-4c23-8624-232d27482a11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-77a3-72af-b9e2-94fd38b5b471.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with a sink, marble countertop, and dark wood cabinets. Features a mirror reflecting a shower and decorative wall art.",
        "public_id": "019db72a-77a3-72af-b9e2-94fd38b5b471",
        "storage_key": "property/6767906449165581/019db72a-77a3-72af-b9e2-94fd38b5b471.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This modern bathroom features a stylish vanity with a marble-look countertop, ample storage, and a large mirror. A decorative accent adds a unique touch to the space.",
      "link": "",
      "alt_text": "Bathroom vanity with a sink, marble countertop, and dark wood cabinets. Features a mirror reflecting a shower and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c612447c-4bfe-493e-b5d2-0dd0b50acdb8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-6fe1-753a-9fd5-7fd16bcdbce5.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with marble countertops, chrome faucet, and decorative accents.",
        "public_id": "019db72a-6fe1-753a-9fd5-7fd16bcdbce5",
        "storage_key": "property/6767906449165581/019db72a-6fe1-753a-9fd5-7fd16bcdbce5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience a spa-like retreat in your personal bathroom, featuring elegant marble countertops and modern fixtures for a touch of luxury.",
      "link": "",
      "alt_text": "Modern bathroom vanity with marble countertops, chrome faucet, and decorative accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0275a294-73ab-47a1-8e83-5c310ad32169",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-7174-7549-952e-570d3304db72.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and nightstand.",
        "public_id": "019db72a-7174-7549-952e-570d3304db72",
        "storage_key": "property/6767906449165581/019db72a-7174-7549-952e-570d3304db72.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, spacious dresser, and a cozy nightstand.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, dresser, and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_84ebf81a-1e7d-41f6-90fb-a7f82a4b6cf3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-6d1a-72e9-af9d-557b40396cba.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity with a marble countertop.",
        "public_id": "019db72a-6d1a-72e9-af9d-557b40396cba",
        "storage_key": "property/6767906449165581/019db72a-6d1a-72e9-af9d-557b40396cba.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a bathtub and shower combo, a modern vanity with a marble countertop, and elegant tile flooring.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity with a marble countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_980de0a5-b017-49e4-ac34-689ff08848c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-521c-7019-a5a0-b669fe0a60d5.webp",
      "image_media": {
        "alt_text": "Living room with a leather sofa, armchair, TV, and bar stools, with a bedroom visible through an open doorway.",
        "public_id": "019db72a-521c-7019-a5a0-b669fe0a60d5",
        "storage_key": "property/6767906449165581/019db72a-521c-7019-a5a0-b669fe0a60d5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable leather sofa, accent armchair, and a large television, perfect for entertaining or relaxing. An adjoining bedroom offers a private retreat.",
      "link": "",
      "alt_text": "Living room with a leather sofa, armchair, TV, and bar stools, with a bedroom visible through an open doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e2b89323-a25d-4d01-8c8c-d81a389048cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-4b7b-76eb-902d-05c2510099fc.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs, featuring a large wall art of a bull.",
        "public_id": "019db72a-4b7b-76eb-902d-05c2510099fc",
        "storage_key": "property/6767906449165581/019db72a-4b7b-76eb-902d-05c2510099fc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy meals with friends and family in this stylish dining area, complete with a round table and elegant seating. The dramatic bull artwork adds a unique touch to the space.",
      "link": "",
      "alt_text": "Dining area with a round table and four chairs, featuring a large wall art of a bull.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4554dcbf-bf89-4883-9113-a70fc5952e02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-4a36-7181-b86e-c8b71a8bd8a9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel refrigerator, dark cabinets, white subway tile backsplash, and marble countertops.",
        "public_id": "019db72a-4a36-7181-b86e-c8b71a8bd8a9",
        "storage_key": "property/6767906449165581/019db72a-4a36-7181-b86e-c8b71a8bd8a9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover the sleek and functional kitchen in your new apartment, featuring stainless steel appliances, ample cabinet space, and elegant marble countertops perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel refrigerator, dark cabinets, white subway tile backsplash, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6e65e526-ccb2-4a3f-a917-40150ba83272",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-45d2-744c-ac64-f8f11d689677.webp",
      "image_media": {
        "alt_text": "King-sized bed with green and black accents in a master bedroom",
        "public_id": "019db72a-45d2-744c-ac64-f8f11d689677",
        "storage_key": "property/6767906449165581/019db72a-45d2-744c-ac64-f8f11d689677.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious master bedroom featuring a king-sized bed with plush bedding, elegant nightstands, a dresser with mirror, and a ceiling fan.",
      "link": "",
      "alt_text": "King-sized bed with green and black accents in a master bedroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cdbbb533-1ea7-4bd6-88c0-614f4c147450",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-4ebd-7430-83b9-8f8cb5955f43.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white countertops.",
        "public_id": "019db72a-4ebd-7430-83b9-8f8cb5955f43",
        "storage_key": "property/6767906449165581/019db72a-4ebd-7430-83b9-8f8cb5955f43.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A beautifully appointed kitchen featuring dark wood cabinetry, a stainless steel range and microwave, and sleek white countertops. Perfect for culinary adventures.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fd375824-98ea-4e25-ab71-77d12d2b0aa8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-412d-700c-b777-f1dc6598e816.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with a leather sofa, dining table, and bar stools.",
        "public_id": "019db72a-412d-700c-b777-f1dc6598e816",
        "storage_key": "property/6767906449165581/019db72a-412d-700c-b777-f1dc6598e816.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious apartment living area seamlessly connected to a modern kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area of an apartment with a leather sofa, dining table, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f42a3012-1a19-47e3-8a0b-33eea2dd0722",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-405f-7128-b59d-cd51af3fbaef.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a marble vanity, sink, toilet, and shower with a patterned curtain.",
        "public_id": "019db72a-405f-7128-b59d-cd51af3fbaef",
        "storage_key": "property/6767906449165581/019db72a-405f-7128-b59d-cd51af3fbaef.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a sleek marble vanity with a single sink, a modern toilet, and a shower/tub combo enclosed by a stylish patterned curtain.",
      "link": "",
      "alt_text": "Modern bathroom with a marble vanity, sink, toilet, and shower with a patterned curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7139006b-e17f-4566-a5a9-3183d1605c06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-17b8-711d-a5d1-2e25fa4063f9.webp",
      "image_media": {
        "alt_text": "Dining area with a round wooden table and four black chairs, and a large plant.",
        "public_id": "019db72a-17b8-711d-a5d1-2e25fa4063f9",
        "storage_key": "property/6767906449165581/019db72a-17b8-711d-a5d1-2e25fa4063f9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy stylish dining in this modern apartment, featuring a round table with four comfortable chairs and elegant decor.",
      "link": "",
      "alt_text": "Dining area with a round wooden table and four black chairs, and a large plant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_49ad5181-e487-47fb-8cde-de08e3d212eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-0c8e-72d3-afc9-0ae1e7a78dc5.webp",
      "image_media": {
        "alt_text": "Living room with green sofa and leather armchair.",
        "public_id": "019db72a-0c8e-72d3-afc9-0ae1e7a78dc5",
        "storage_key": "property/6767906449165581/019db72a-0c8e-72d3-afc9-0ae1e7a78dc5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a plush green sofa, a comfortable leather armchair, a dining table with chairs, and large windows with blinds.",
      "link": "",
      "alt_text": "Living room with green sofa and leather armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_04cd6e3d-c6c6-45fe-b7e7-687c6b37a907",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-27f7-743e-ba45-6a7ece6d4c3e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, sink, mirror, and dog-themed decor.",
        "public_id": "019db72a-27f7-743e-ba45-6a7ece6d4c3e",
        "storage_key": "property/6767906449165581/019db72a-27f7-743e-ba45-6a7ece6d4c3e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish apartment bathroom featuring a marble vanity, a spacious mirror, and unique dog-themed wall art and accessories.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, sink, mirror, and dog-themed decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_295e914a-a670-4d3c-86e4-2d2a13457b62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-13f7-708b-934f-a4295b187694.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light grey cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019db72a-13f7-708b-934f-a4295b187694",
        "storage_key": "property/6767906449165581/019db72a-13f7-708b-934f-a4295b187694.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this sleek and modern kitchen featuring ample cabinet space, durable marble countertops, and stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with light grey cabinets, stainless steel appliances, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0b825763-e307-4780-9e41-e6b4d3d14ac2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-157a-727b-8cb8-a59f19289fca.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and weight bench.",
        "public_id": "019db72a-157a-727b-8cb8-a59f19289fca",
        "storage_key": "property/6767906449165581/019db72a-157a-727b-8cb8-a59f19289fca.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines and free weights for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, and weight bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_92b3c3be-1062-48ac-8b85-f58ed5e2bda5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-137f-76bb-a5e7-1e750c98026e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white subway tile backsplash, and marble countertops.",
        "public_id": "019db72a-137f-76bb-a5e7-1e750c98026e",
        "storage_key": "property/6767906449165581/019db72a-137f-76bb-a5e7-1e750c98026e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and beautiful marble countertops, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white subway tile backsplash, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_901ce0bf-d9dc-43fe-a96d-46a56e4ee3ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-0432-7099-880b-9fa7f7f60243.webp",
      "image_media": {
        "alt_text": "A cozy bedroom with a white king-sized bed, nightstands, and a ceiling fan.",
        "public_id": "019db72a-0432-7099-880b-9fa7f7f60243",
        "storage_key": "property/6767906449165581/019db72a-0432-7099-880b-9fa7f7f60243.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush king-sized bed and elegant nightstands.",
      "link": "",
      "alt_text": "A cozy bedroom with a white king-sized bed, nightstands, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_011637d8-0c92-4dc7-b1ba-7d70e7b8a11b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-f375-711a-b3af-9f45b79eb939.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with a shower.",
        "public_id": "019db729-f375-711a-b3af-9f45b79eb939",
        "storage_key": "property/6767906449165581/019db729-f375-711a-b3af-9f45b79eb939.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Freshen up in this modern bathroom, featuring a sleek vanity, a comfortable toilet, and a pristine bathtub with a shower.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with a shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_45f449a8-568e-41f2-b4ff-3b859a552d65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-dfdf-760b-9b0b-08c2887e5c0d.webp",
      "image_media": {
        "alt_text": "State-of-the-art fitness center with cardio equipment and weight machines.",
        "public_id": "019db729-dfdf-760b-9b0b-08c2887e5c0d",
        "storage_key": "property/6767906449165581/019db729-dfdf-760b-9b0b-08c2887e5c0d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring treadmills, ellipticals, and weight machines.",
      "link": "",
      "alt_text": "State-of-the-art fitness center with cardio equipment and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_85997eec-779f-4c19-b0dd-8af093cb9e9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-9353-778e-a8e5-0a25bd1e18b4.webp",
      "image_media": {
        "alt_text": "Dining area with a marble table and chairs, adjacent to a workspace with a desk and chair.",
        "public_id": "019db729-9353-778e-a8e5-0a25bd1e18b4",
        "storage_key": "property/6767906449165581/019db729-9353-778e-a8e5-0a25bd1e18b4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A stylish dining area featuring a marble-top table and upholstered chairs, flowing into a functional workspace with a desk and chair, perfect for any modern apartment.",
      "link": "",
      "alt_text": "Dining area with a marble table and chairs, adjacent to a workspace with a desk and chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c8980e90-62d9-468d-bd13-48e691b4324b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-9269-74c9-acf0-5aa6bdd289be.webp",
      "image_media": {
        "alt_text": "Living room and dining area with a sofa, accent chairs, and a dining table.",
        "public_id": "019db729-9269-74c9-acf0-5aa6bdd289be",
        "storage_key": "property/6767906449165581/019db729-9269-74c9-acf0-5aa6bdd289be.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish and spacious living room and dining area, perfect for entertaining or relaxing. Features a comfortable sofa, accent chairs, and a modern dining set.",
      "link": "",
      "alt_text": "Living room and dining area with a sofa, accent chairs, and a dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ff6e95d6-6316-4f93-a730-f973286ff64b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-9228-76cd-bad4-2a42d6703df9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with marble countertops and stainless steel appliances, opens to a living area.",
        "public_id": "019db729-9228-76cd-bad4-2a42d6703df9",
        "storage_key": "property/6767906449165581/019db729-9228-76cd-bad4-2a42d6703df9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and bright apartment kitchen featuring contemporary finishes, ample counter space, and a seamless flow into the living room.",
      "link": "",
      "alt_text": "Modern kitchen with marble countertops and stainless steel appliances, opens to a living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5604f071-af7a-4f52-b85a-0f57a29d941f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-9129-7512-96d7-a2f43f4bcbff.webp",
      "image_media": {
        "alt_text": "Modern grey kitchen with stainless steel appliances and marble countertops.",
        "public_id": "019db729-9129-7512-96d7-a2f43f4bcbff",
        "storage_key": "property/6767906449165581/019db729-9129-7512-96d7-a2f43f4bcbff.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and bright modern kitchen featuring sleek grey cabinetry, stainless steel appliances, and elegant marble countertops. Perfect for preparing meals and entertaining guests.",
      "link": "",
      "alt_text": "Modern grey kitchen with stainless steel appliances and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4794b38e-be2b-4089-852a-a3b10db19412",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-7460-7649-995b-34feaf0849c5.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with dumbbells, weight machines, and exercise balls.",
        "public_id": "019db729-7460-7649-995b-34feaf0849c5",
        "storage_key": "property/6767906449165581/019db729-7460-7649-995b-34feaf0849c5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide selection of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Well-equipped fitness center with dumbbells, weight machines, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d5ed38b2-dd1c-462d-8459-718a78ef48e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-6ff8-7409-8e08-5764ef0b3b6b.webp",
      "image_media": {
        "alt_text": "Desk and chair in a well-lit corner with a plant and large windows.",
        "public_id": "019db729-6ff8-7409-8e08-5764ef0b3b6b",
        "storage_key": "property/6767906449165581/019db729-6ff8-7409-8e08-5764ef0b3b6b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Create a productive home office space with this well-designed corner desk and comfortable chair, illuminated by natural light from large windows.",
      "link": "",
      "alt_text": "Desk and chair in a well-lit corner with a plant and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_503f88e8-e9f8-4650-94d3-627ff3a4d203",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-6fad-7053-a031-0a53313e47ed.webp",
      "image_media": {
        "alt_text": "Living room with a couch, ottoman, and fireplace.",
        "public_id": "019db729-6fad-7053-a031-0a53313e47ed",
        "storage_key": "property/6767906449165581/019db729-6fad-7053-a031-0a53313e47ed.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a plush sofa, cozy ottoman, and modern fireplace. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with a couch, ottoman, and fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3437e689-0504-4e3d-9167-37a311494d20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-5935-76bf-be78-2f73ed710adf.webp",
      "image_media": {
        "alt_text": "Modern communal lounge area with a fireplace, comfortable seating, and high ceilings.",
        "public_id": "019db729-5935-76bf-be78-2f73ed710adf",
        "storage_key": "property/6767906449165581/019db729-5935-76bf-be78-2f73ed710adf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish communal lounge, featuring a cozy fireplace and ample seating, perfect for socializing or quiet reflection.",
      "link": "",
      "alt_text": "Modern communal lounge area with a fireplace, comfortable seating, and high ceilings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9f8250b2-7863-47ed-9514-0669496b05d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-2b11-71ad-9d4f-10f1453b903b.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with agility equipment, including a red tunnel and blue weave poles.",
        "public_id": "019db729-2b11-71ad-9d4f-10f1453b903b",
        "storage_key": "property/6767906449165581/019db729-2b11-71ad-9d4f-10f1453b903b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with agility obstacles for your furry friends to play and train.",
      "link": "",
      "alt_text": "A fenced-in dog park with agility equipment, including a red tunnel and blue weave poles.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_699a22d5-8c4c-49f5-864b-05d1537271d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-4549-73ff-9f77-62b3bb952438.webp",
      "image_media": {
        "alt_text": "Luxury apartment community lounge area with fireplace and modern seating.",
        "public_id": "019db729-4549-73ff-9f77-62b3bb952438",
        "storage_key": "property/6767906449165581/019db729-4549-73ff-9f77-62b3bb952438.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience comfort and style in our stunning community lounge, featuring a cozy fireplace and elegant seating perfect for relaxation and socializing.",
      "link": "",
      "alt_text": "Luxury apartment community lounge area with fireplace and modern seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_38de75f5-493b-451f-b025-eaf6c4df1d8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-2721-76fa-b293-5d4a8ad27d37.webp",
      "image_media": {
        "alt_text": "Community lounge with a pool table and shuffleboard table.",
        "public_id": "019db729-2721-76fa-b293-5d4a8ad27d37",
        "storage_key": "property/6767906449165581/019db729-2721-76fa-b293-5d4a8ad27d37.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy leisure time in the community lounge, featuring a pool table and shuffleboard, perfect for resident entertainment.",
      "link": "",
      "alt_text": "Community lounge with a pool table and shuffleboard table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2267eea6-3313-42c5-89c6-f77a06f451fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-1eec-742b-89bf-83bce0768664.webp",
      "image_media": {
        "alt_text": "Walkway between apartment buildings with manicured lawns.",
        "public_id": "019db729-1eec-742b-89bf-83bce0768664",
        "storage_key": "property/6767906449165581/019db729-1eec-742b-89bf-83bce0768664.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy scenic strolls on the well-maintained pathways winding through lush green lawns, connecting beautifully designed apartment buildings.",
      "link": "",
      "alt_text": "Walkway between apartment buildings with manicured lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2692a9f7-7e9e-4ac5-b859-66d713ffca6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-19db-7149-8c06-04dbc734a545.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with agility equipment and a welcome sign.",
        "public_id": "019db729-19db-7149-8c06-04dbc734a545",
        "storage_key": "property/6767906449165581/019db729-19db-7149-8c06-04dbc734a545.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our on-site pet park, \"Oak Woof Grove,\" complete with agility equipment for your furry friends.",
      "link": "",
      "alt_text": "A fenced-in dog park with agility equipment and a welcome sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d496fe98-0002-4a8b-b350-b23dc413f72e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-02cf-72ce-931e-a1bc1fde7efb.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with two built-in grills and a picnic table with umbrella.",
        "public_id": "019db729-02cf-72ce-931e-a1bc1fde7efb",
        "storage_key": "property/6767906449165581/019db729-02cf-72ce-931e-a1bc1fde7efb.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining at the community grilling station, complete with two high-quality grills and a comfortable picnic table area.",
      "link": "",
      "alt_text": "Outdoor grilling station with two built-in grills and a picnic table with umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_208714b7-adb2-467d-ab40-2184d6844c14",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-0047-74d1-9ec4-af3918e5a569.webp",
      "image_media": {
        "alt_text": "Covered outdoor lounge area with seating, tables, and a TV.",
        "public_id": "019db729-0047-74d1-9ec4-af3918e5a569",
        "storage_key": "property/6767906449165581/019db729-0047-74d1-9ec4-af3918e5a569.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our community's stylish outdoor lounge, complete with comfortable seating, tables, and a large screen TV for entertainment.",
      "link": "",
      "alt_text": "Covered outdoor lounge area with seating, tables, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ed62cba3-9fa0-4246-abf8-cb21e2db5fb5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-1197-741d-9347-b26f87c29467.webp",
      "image_media": {
        "alt_text": "Billiard table in a community lounge with modern decor and large windows.",
        "public_id": "019db729-1197-741d-9347-b26f87c29467",
        "storage_key": "property/6767906449165581/019db729-1197-741d-9347-b26f87c29467.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a game of billiards in our stylish community lounge, featuring a pool table, comfortable seating, and entertainment screens.",
      "link": "",
      "alt_text": "Billiard table in a community lounge with modern decor and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1ab9fd5c-a8c9-41f8-b8d0-1ece796189fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db728-d9d0-749f-bdd9-a88997677d41.webp",
      "image_media": {
        "alt_text": "97 North Oak Apartments monument sign",
        "public_id": "019db728-d9d0-749f-bdd9-a88997677d41",
        "storage_key": "property/6767906449165581/019db728-d9d0-749f-bdd9-a88997677d41.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to 97 North Oak Apartments, where modern living meets comfort. Explore our beautiful community.",
      "link": "",
      "alt_text": "97 North Oak Apartments monument sign",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5be5f69f-3dbe-4539-b5ca-33a5aab29155",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db728-f090-7749-ad7a-c01a5f47d0df.webp",
      "image_media": {
        "alt_text": "Apartment complex outdoor swimming pool with lounge chairs and buildings in the background.",
        "public_id": "019db728-f090-7749-ad7a-c01a5f47d0df",
        "storage_key": "property/6767906449165581/019db728-f090-7749-ad7a-c01a5f47d0df.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping at our apartment community.",
      "link": "",
      "alt_text": "Apartment complex outdoor swimming pool with lounge chairs and buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d0512f7a-209c-41a9-8f98-8429e3575ad5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db728-dab4-74f9-b158-201e5291408b.webp",
      "image_media": {
        "alt_text": "Swimming pool and lounge chairs with apartment buildings in the background",
        "public_id": "019db728-dab4-74f9-b158-201e5291408b",
        "storage_key": "property/6767906449165581/019db728-dab4-74f9-b158-201e5291408b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and beautiful apartment buildings.",
      "link": "",
      "alt_text": "Swimming pool and lounge chairs with apartment buildings in the background",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_75518b30-0ebe-47d6-a6cf-e522146adfbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db728-cb27-77dc-879e-2f8183503827.webp",
      "image_media": {
        "alt_text": "The monument sign for Ninety-Seven North Oak Apartments.",
        "public_id": "019db728-cb27-77dc-879e-2f8183503827",
        "storage_key": "property/6767906449165581/019db728-cb27-77dc-879e-2f8183503827.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Ninety-Seven North Oak Apartments, a premier apartment community.",
      "link": "",
      "alt_text": "The monument sign for Ninety-Seven North Oak Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_60c01bb1-76b0-4d9f-a818-c92fb6b0867c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db728-c68d-735b-9ec0-19c0da5db30f.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with modern design and landscaping.",
        "public_id": "019db728-c68d-735b-9ec0-19c0da5db30f",
        "storage_key": "property/6767906449165581/019db728-c68d-735b-9ec0-19c0da5db30f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the modern apartment building exterior, showcasing its contemporary architecture and well-maintained grounds.",
      "link": "",
      "alt_text": "Exterior of apartment building with modern design and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ff6ad537-16e6-4f1b-8daf-b8a9b3189b35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db728-c0ca-7479-991d-9bdad820fea3.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with garages.",
        "public_id": "019db728-c0ca-7479-991d-9bdad820fea3",
        "storage_key": "property/6767906449165581/019db728-c0ca-7479-991d-9bdad820fea3.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "View of the exterior of apartment buildings, showcasing individual garages and modern architectural details. This image captures the overall community aesthetic.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with garages.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4ccf4f43-67a1-4d4c-b4f5-a70bb5a1d68f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db728-cf14-7609-81f9-a07d72db19eb.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019db728-cf14-7609-81f9-a07d72db19eb",
        "storage_key": "property/6767906449165581/019db728-cf14-7609-81f9-a07d72db19eb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by our sparkling swimming pool, featuring comfortable lounge chairs and a resort-like atmosphere perfect for soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_291cfc27-e97c-4681-8a99-10de06945172",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db728-cdfe-7644-ab46-41ed351d3602.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a fire pit and lounge chairs in front of apartment buildings.",
        "public_id": "019db728-cdfe-7644-ab46-41ed351d3602",
        "storage_key": "property/6767906449165581/019db728-cdfe-7644-ab46-41ed351d3602.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize around the fire pit in our inviting outdoor seating area. Perfect for enjoying cool evenings with friends and neighbors.",
      "link": "",
      "alt_text": "Outdoor seating area with a fire pit and lounge chairs in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_be80ecd8-d33d-4101-9597-00afa2d34c70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "6501 NW Barry Rd, Kansas City, MO 64154, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches and hot fries. They highlight the fast service, even during busy periods, and the efficient drive-thru design. They also like the friendly and polite staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-9fea-7017-9bbf-96994ed65cee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-9fea-7017-9bbf-96994ed65cee",
        "storage_key": "property/6767906449165581/019cfb37-9fea-7017-9bbf-96994ed65cee.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/mo/i-29-barry-road?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2275380395166734837&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "39.2461924",
      "poi_longitude": "-94.6539813",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-587-0411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b2dd-71c0-a39e-557f679d06da",
        "storage_key": "property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeYVmXkhfwIcR9RnN9mnGkx8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_92e8cea7-c451-4364-963e-18e816dcfec5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "8051 Roanridge Rd, Kansas City, MO 64151, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and pork chops, along with warm rolls and cinnamon butter. They highlight the generous portions, reasonable prices, and lively atmosphere. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-9ea3-755c-a12b-33eae6d3ceb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-9ea3-755c-a12b-33eae6d3ceb6",
        "storage_key": "property/6767906449165581/019cfb37-9ea3-755c-a12b-33eae6d3ceb6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/missouri/kansas-city?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=16198406781598789157&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "39.2412883",
      "poi_longitude": "-94.656915",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-741-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b2dd-71c0-a39e-557f679d06da",
        "storage_key": "property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ7mtr0VfwIcRJW55ICVNzOA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_aeae9c68-4507-48aa-81f0-d1f0806f1156",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "8771 N Ambassador Dr, Kansas City, MO 64154, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "Diners say this fast food restaurant serves up delicious chicken fingers, Texas toast, and coleslaw, with many raving about the Cane's sauce. They also highlight the friendly and efficient service, and the consistently hot and fresh food.\n\nSome reviews mention the chicken fingers can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-9f2f-744a-8788-682ceaaaa836.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-9f2f-744a-8788-682ceaaaa836",
        "storage_key": "property/6767906449165581/019cfb37-9f2f-744a-8788-682ceaaaa836.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/mo/kansas-city/8771-n.-ambassador-dr.",
      "poi_directions_map_url": "https://maps.google.com/?cid=15636708610982546926&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "39.2567669",
      "poi_longitude": "-94.6489296",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-584-0502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b2dd-71c0-a39e-557f679d06da",
        "storage_key": "property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo9IZtDNfwIcR7g3ohaK_ANk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_70615131-78ac-4a25-83ce-e60bbcf002ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "8800 N Skyview Ave, Kansas City, MO 64154, USA",
      "poi_short_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_long_description": "Diners say this buffet restaurant offers a wide variety of dishes, including steak, fried chicken, ham, and a salad bar. They also highlight the friendly and attentive service, and the affordable price.\n\nSome reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-9e90-71ab-8336-8107d7922e3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-9e90-71ab-8336-8107d7922e3b",
        "storage_key": "property/6767906449165581/019cfb37-9e90-71ab-8336-8107d7922e3b.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/location-detail/2605/golden-corral-n-skyview-ave/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=2605",
      "poi_directions_map_url": "https://maps.google.com/?cid=9529424459634360752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "39.2553379",
      "poi_longitude": "-94.650344",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-505-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b2dd-71c0-a39e-557f679d06da",
        "storage_key": "property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQS4S8S9fwIcRsMFslg5RP4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_2384e198-01b6-4373-b6df-44bde22af485",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Main Event Kansas City North",
      "poi_type": "Restaurants",
      "poi_address": "8081 NW Roanridge Rd., Kansas City, MO 64151, USA",
      "poi_short_description": "Pizza, wings, laser-tag eatery featuring bowling lanes and a full-service bar.",
      "poi_long_description": "People say this restaurant offers bowling, arcade games, and laser tag. They also highlight the fun atmosphere and friendly staff.\n\nOther reviews mention some games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-9ea3-755c-a12b-3440d6d1e768.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-9ea3-755c-a12b-3440d6d1e768",
        "storage_key": "property/6767906449165581/019cfb37-9ea3-755c-a12b-3440d6d1e768.webp",
        "width": 1280,
        "height": 708
      },
      "poi_business_url": "http://www.mainevent.com/locations/missouri/kansas-city-north",
      "poi_directions_map_url": "https://maps.google.com/?cid=15555059811509003358&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "main-event-kansas-city-north",
      "poi_latitude": "39.2417979",
      "poi_longitude": "-94.654988",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-281-2020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b2dd-71c0-a39e-557f679d06da",
        "storage_key": "property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHVdq10VfwIcRXuTy_Hus3tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e4428935-44c5-4d3c-a8f5-8cf05f55bee6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "3701 NW 90th St, Kansas City, MO 64154, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "People say this home improvement store offers a wide selection of products, including lumber, lighting, and appliances. They also highlight the competitive prices, the 11% rebate program, and the convenient layout.\n\nOther reviews mention the customer service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-9f4a-75eb-9c2c-c1d6c33e884e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-9f4a-75eb-9c2c-c1d6c33e884e",
        "storage_key": "property/6767906449165581/019cfb37-9f4a-75eb-9c2c-c1d6c33e884e.webp",
        "width": 1280,
        "height": 899
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3342&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=7106698464765649376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "menards",
      "poi_latitude": "39.255619",
      "poi_longitude": "-94.6228408",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-436-0723",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b24f-7589-bb27-8b73388a0919.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b24f-7589-bb27-8b73388a0919",
        "storage_key": "property/6767906449165581/019cfb37-b24f-7589-bb27-8b73388a0919.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJpbvzFcRYwIcR4KErzpkQoGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_faf3767b-863d-4a2e-84ea-65ba8d484b87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Hy-Vee Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "8301 N St Clair Ave, Kansas City, MO 64151, USA",
      "poi_short_description": "Neighborhood chain grocery store offering a range of produce, meats, seafood, and baked goods.",
      "poi_long_description": "People say this grocery store offers a wide variety of food, liquor, and fresh produce, and has a pharmacy and gas station. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-e029-7789-8a9e-d951eadcf77b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-e029-7789-8a9e-d951eadcf77b",
        "storage_key": "property/6767906449165581/019cfb37-e029-7789-8a9e-d951eadcf77b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hy-vee.com/stores/detail.aspx?s=77&utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=5363076948978843234&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hy-vee-grocery-store",
      "poi_latitude": "39.2452729",
      "poi_longitude": "-94.6457346",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-505-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b230-74f5-b49a-910c864bcf13.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b230-74f5-b49a-910c864bcf13",
        "storage_key": "property/6767906449165581/019cfb37-b230-74f5-b49a-910c864bcf13.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFyOPOktfwIcRYj74_hF6bUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6e36387e-3cf7-482a-8193-434f2f1e281a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "8900 NW Skyview Ave, Kansas City, MO 64154, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide selection of flowers, tools, and appliances, and has helpful and friendly staff. They also highlight the clean and well-organized interior, with ample parking and lighting.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-e06f-77a9-bf4f-f0267b596a58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-e06f-77a9-bf4f-f0267b596a58",
        "storage_key": "property/6767906449165581/019cfb37-e06f-77a9-bf4f-f0267b596a58.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "https://www.homedepot.com/l/North-Kansas-City/MO/Kansas-City/64154/8460?emt=MSEN?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=3940999963763534166&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "39.2560605",
      "poi_longitude": "-94.6525641",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-741-2580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b24f-7589-bb27-8b73388a0919.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b24f-7589-bb27-8b73388a0919",
        "storage_key": "property/6767906449165581/019cfb37-b24f-7589-bb27-8b73388a0919.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZ1Df2C9fwIcRVunzM5Y-sTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_162d253f-ba15-482c-8c92-d65db8eac419",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Metropolitan Community College - Maple Woods",
      "poi_type": "Education",
      "poi_address": "2601 NE Barry Rd, Kansas City, MO 64156, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-a3ee-759e-802a-9bc6b85dcbfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-a3ee-759e-802a-9bc6b85dcbfe",
        "storage_key": "property/6767906449165581/019cfb37-a3ee-759e-802a-9bc6b85dcbfe.webp",
        "width": 1200,
        "height": 803
      },
      "poi_business_url": "https://mcckc.edu/maplewoods",
      "poi_directions_map_url": "https://maps.google.com/?cid=9374804838064555436&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metropolitan-community-college---maple-woods",
      "poi_latitude": "39.246921",
      "poi_longitude": "-94.5478501",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-604-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b24a-751e-9929-3a537973210d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b24a-751e-9929-3a537973210d",
        "storage_key": "property/6767906449165581/019cfb37-b24a-751e-9929-3a537973210d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsz0_u-5XwIcRrIVzk1T_GYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0d015bc2-68b6-440e-891e-1a501448658e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Mid-Continent Public Library - Green Hills Library Center",
      "poi_type": "Education",
      "poi_address": "8581 N Green Hills Rd, Kansas City, MO 64154, USA",
      "poi_short_description": "Family-friendly library providing books, DVDs and programs, as well as meeting rooms and study spaces.",
      "poi_long_description": "People say this library offers a wide selection of books, quiet study areas, and a dedicated children's area. They highlight the convenient location, the availability of resources like computers and printing services, and the presence of a cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-e345-73cb-8a04-678f08d81dfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-e345-73cb-8a04-678f08d81dfb",
        "storage_key": "property/6767906449165581/019cfb37-e345-73cb-8a04-678f08d81dfb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mymcpl.org/locations/green-hills-library-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9022124123893074582&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mid-continent-public-library---green-hills-library-center",
      "poi_latitude": "39.2495521",
      "poi_longitude": "-94.6303676",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-741-9011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b24a-751e-9929-3a537973210d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b24a-751e-9929-3a537973210d",
        "storage_key": "property/6767906449165581/019cfb37-b24a-751e-9929-3a537973210d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaSMHM4dZwIcRlgoh5BYGNX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_66721043-9773-4d5c-abcc-0c6b2c1dff64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Mid-Continent Public Library - Woodneath Library Center",
      "poi_type": "Education",
      "poi_address": "8900 NE Flintlock Rd, Kansas City, MO 64157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-a3fd-743c-9214-20283668ed6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-a3fd-743c-9214-20283668ed6e",
        "storage_key": "property/6767906449165581/019cfb37-a3fd-743c-9214-20283668ed6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mymcpl.org/locations/woodneath-library-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=10578535368113534819&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mid-continent-public-library---woodneath-library-center",
      "poi_latitude": "39.2536339",
      "poi_longitude": "-94.4674451",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-883-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b24a-751e-9929-3a537973210d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b24a-751e-9929-3a537973210d",
        "storage_key": "property/6767906449165581/019cfb37-b24a-751e-9929-3a537973210d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp5kDnelVwIcRYzdQrN6BzpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_b66cb75f-7298-4517-b2bf-3662fc329116",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Springs Aquatic Center",
      "poi_type": "Entertainment",
      "poi_address": "9400 N Congress Ave, Kansas City, MO 64153, USA",
      "poi_short_description": "Seasonal swimming complex featuring pools, plus a leisure area with a lazy river & water slides.",
      "poi_long_description": "Seasonal swimming complex featuring pools, plus a leisure area with a lazy river & water slides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-a529-705e-823d-3ce1456953ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-a529-705e-823d-3ce1456953ec",
        "storage_key": "property/6767906449165581/019cfb37-a529-705e-823d-3ce1456953ec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kcparks.org/places/the-springs-water-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10420557508559265262&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "springs-aquatic-center",
      "poi_latitude": "39.26326",
      "poi_longitude": "-94.669313",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-513-7860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b247-7010-b20c-b222fe20d541",
        "storage_key": "property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAc_7MxlfwIcR7l0089dBnZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_c6ac324f-5999-43b9-99d7-3f376e86c580",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Shoal Creek Living History Museum",
      "poi_type": "Entertainment",
      "poi_address": "7000 NE Barry Rd, Kansas City, MO 64156, USA",
      "poi_short_description": "An 80-acre park with authentic buildings documenting Missouri history, plus reenactments & trails.",
      "poi_long_description": "Visitors say this history museum offers a leisurely walk through a historic town with buffalo nearby. They also highlight the museum's free admission, walking trails, and photo opportunities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-e498-724e-9aa7-32fefd85f134.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-e498-724e-9aa7-32fefd85f134",
        "storage_key": "property/6767906449165581/019cfb37-e498-724e-9aa7-32fefd85f134.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://shoalcreeklivinghistorymuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7039840035552825463&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "shoal-creek-living-history-museum",
      "poi_latitude": "39.252643",
      "poi_longitude": "-94.5015404",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 816-792-2655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b235-748b-9cd7-3cdff5b5c0fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b235-748b-9cd7-3cdff5b5c0fc",
        "storage_key": "property/6767906449165581/019cfb37-b235-748b-9cd7-3cdff5b5c0fc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJmVzqC8FXwIcRdxCzsjaJsmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_38fc79ac-9303-4929-b833-cc80c5e14c0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Kansas City Northern Railroad",
      "poi_type": "Entertainment",
      "poi_address": "6060 NW Waukomis Dr, Kansas City, MO 64151, USA",
      "poi_short_description": "Miniature railway in Frank Vaydik Park open weekends May–Sep for rides around a 1/2-mi. track.",
      "poi_long_description": "People say this museum offers a fun train ride, a small playground, and plenty of room to play. They highlight the affordable price, the family-friendly atmosphere, and the ongoing expansion of the track and facilities. They also like the friendly and helpful volunteers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-e36c-722b-bdc4-367aafc2ad30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-e36c-722b-bdc4-367aafc2ad30",
        "storage_key": "property/6767906449165581/019cfb37-e36c-722b-bdc4-367aafc2ad30.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.kcnrr.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3228289762664381209&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kansas-city-northern-railroad",
      "poi_latitude": "39.2039529",
      "poi_longitude": "-94.611023",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-746-5663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b235-748b-9cd7-3cdff5b5c0fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b235-748b-9cd7-3cdff5b5c0fc",
        "storage_key": "property/6767906449165581/019cfb37-b235-748b-9cd7-3cdff5b5c0fc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJIyxGLEn2wIcRGfujV28wzSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_2ef4e3b8-943e-4444-af73-29f84f96d3ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Fred and Shirley Pryor YMCA Challenger Sports Complex",
      "poi_type": "Entertainment",
      "poi_address": "2100 NW 87th Terrace, Kansas City, MO 64154, USA",
      "poi_short_description": "Park featuring a rubberized baseball field and areas for soccer and football.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-e371-707b-91b9-6117a05c03c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-e371-707b-91b9-6117a05c03c1",
        "storage_key": "property/6767906449165581/019cfb37-e371-707b-91b9-6117a05c03c1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kansascityymca.org/programs/adaptive-challenger/sports-complex",
      "poi_directions_map_url": "https://maps.google.com/?cid=902892512523238543&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fred-and-shirley-pryor-ymca-challenger-sports-complex",
      "poi_latitude": "39.2535262",
      "poi_longitude": "-94.6062909",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b232-7208-a6bd-eb9fb3abf1a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b232-7208-a6bd-eb9fb3abf1a0",
        "storage_key": "property/6767906449165581/019cfb37-b232-7208-a6bd-eb9fb3abf1a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDbrrrPVYwIcRj7xO1_S3hww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_39942285-5aa6-4ab1-8ad0-4d4ecbf087d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Atkins-Johnson Farm and Museum",
      "poi_type": "Entertainment",
      "poi_address": "4109 NE Pleasant Valley Rd, Kansas City, MO 64119, USA",
      "poi_short_description": "History museum housed in an old farmhouse, with a market, and special events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-a61b-72ee-8a53-0ec69214b1a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-a61b-72ee-8a53-0ec69214b1a8",
        "storage_key": "property/6767906449165581/019cfb37-a61b-72ee-8a53-0ec69214b1a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.atkinsjohnsonfarm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5883006050470701194&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "atkins-johnson-farm-and-museum",
      "poi_latitude": "39.212782",
      "poi_longitude": "-94.5310088",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-453-3276",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b235-748b-9cd7-3cdff5b5c0fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b235-748b-9cd7-3cdff5b5c0fc",
        "storage_key": "property/6767906449165581/019cfb37-b235-748b-9cd7-3cdff5b5c0fc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJw88vsGn4wIcRiqjHWdWipFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_f657e62d-7d5f-4b0d-a1d9-c4298686e96c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "470 NE Barry Rd, Kansas City, MO 64155, USA",
      "poi_short_description": "Gym with affordable memberships offering a circuit-training area and cardio machines.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and weights. They also highlight the friendly and helpful staff, and the clean environment.\n\nOther reviews mention the gym can be closed unexpectedly.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-e41b-750b-a8d3-43bbe4c414d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-e41b-750b-a8d3-43bbe4c414d5",
        "storage_key": "property/6767906449165581/019cfb37-e41b-750b-a8d3-43bbe4c414d5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/kansas-city-north-oak-mo?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=3306209639745088981&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.2491588",
      "poi_longitude": "-94.5732824",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-420-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b247-7010-b20c-b222fe20d541",
        "storage_key": "property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTSCaMhFYwIcR1W36eSYE4i0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_87bf2675-9503-49a5-b39e-b11a194639a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Mercury Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "10551 N Ambassador Dr, Kansas City, MO 64153, USA",
      "poi_short_description": "Gym featuring classes and tumbling, plus a 25,000-square-foot facility.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-a8b4-76cb-a48e-97b537ab4539.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-a8b4-76cb-a48e-97b537ab4539",
        "storage_key": "property/6767906449165581/019cfb37-a8b4-76cb-a48e-97b537ab4539.webp",
        "width": 487,
        "height": 288
      },
      "poi_business_url": "http://mercurygymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3496995816491958630&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercury-gymnastics",
      "poi_latitude": "39.284875",
      "poi_longitude": "-94.6742389",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-880-9996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b24a-751e-9929-3a537973210d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b24a-751e-9929-3a537973210d",
        "storage_key": "property/6767906449165581/019cfb37-b24a-751e-9929-3a537973210d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw-oexe1ewIcRZsEHzyrThzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_29133ab4-64d1-48a5-858e-a74a41e8bc8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - Liberty",
      "poi_type": "Health and Wellness",
      "poi_address": "8260 N Ditzler Ave, Kansas City, MO 64158, USA",
      "poi_short_description": "Chain health club offering group fitness classes, weight and cardio machines, and childcare.",
      "poi_long_description": "People say this gym is clean and has friendly staff who are always willing to help. They also highlight the welcoming atmosphere and well-maintained equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-a936-75b9-ad2b-759df0a2d446.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-a936-75b9-ad2b-759df0a2d446",
        "storage_key": "property/6767906449165581/019cfb37-a936-75b9-ad2b-759df0a2d446.webp",
        "width": 842,
        "height": 474
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/liberty.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=16367127127140237870&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---liberty",
      "poi_latitude": "39.2431907",
      "poi_longitude": "-94.4686586",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-407-9344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b247-7010-b20c-b222fe20d541",
        "storage_key": "property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG8PzifBVwIcRLoLaxme3I-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_26ced553-d7cd-4103-8f61-7acf120a106a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Salon Inspire",
      "poi_type": "Health and Wellness",
      "poi_address": "129 NE 91 St, Kansas City, MO 64155, USA",
      "poi_short_description": "Friendly, welcoming, relaxed salon offering a variety of haircuts, blowouts, coloring, extensions and scalp massages, as well as pedicures.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-e489-775a-a7c8-32d4f7544480.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-e489-775a-a7c8-32d4f7544480",
        "storage_key": "property/6767906449165581/019cfb37-e489-775a-a7c8-32d4f7544480.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://saloninspirekc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13730457618670501898&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "salon-inspire",
      "poi_latitude": "39.2591553",
      "poi_longitude": "-94.5783504",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-216-7726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b247-7010-b20c-b222fe20d541",
        "storage_key": "property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6w5ieDlYwIcRCkBpBHVijL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_4ed6363c-e535-4075-b108-049255aa58f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Gladstone Animal Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "7915 N Oak Trafficway, Gladstone, MO 64118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-a9a3-704c-8d3d-2ff38f736ee0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-a9a3-704c-8d3d-2ff38f736ee0",
        "storage_key": "property/6767906449165581/019cfb37-a9a3-704c-8d3d-2ff38f736ee0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://gladvets.com/?utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6003131147656611248&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gladstone-animal-clinic",
      "poi_latitude": "39.2383909",
      "poi_longitude": "-94.5752932",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-436-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b247-7010-b20c-b222fe20d541",
        "storage_key": "property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLVvqkOX3wIcRsMUnDPlnT1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_235e8b8b-9288-4d83-bee6-459278cbdd02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - Boardwalk",
      "poi_type": "Health and Wellness",
      "poi_address": "8628 N Boardwalk Ave Ste 12, Kansas City, MO 64154, USA",
      "poi_short_description": "Clean gym offering classes, cardio equipment and weights as well as a sauna.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including rigs, free weights, cardio machines, and lifting machines. They highlight the clean facilities, friendly staff, and positive, judgment-free atmosphere. They also like the spacious layout and the availability of amenities such as a sauna and childcare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-a9b5-7537-987f-71694215c2e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-a9b5-7537-987f-71694215c2e5",
        "storage_key": "property/6767906449165581/019cfb37-a9b5-7537-987f-71694215c2e5.webp",
        "width": 867,
        "height": 488
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/boardwalk.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=13929944502685125300&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---boardwalk",
      "poi_latitude": "39.2534483",
      "poi_longitude": "-94.6525799",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-214-5466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b247-7010-b20c-b222fe20d541",
        "storage_key": "property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvf2S5zZfwIcRtMpzn7gaUcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e3455515-28dd-45be-8f4b-d547b0210287",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Catalyst Barber Co. - Gladstone",
      "poi_type": "Health and Wellness",
      "poi_address": "7221 N Oak Trafficway, Kansas City, MO 64118, USA",
      "poi_short_description": "Laid-back barbershop where staff cut men's hair and trim beards, plus provide hot towel shaves.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-e6bc-736c-a288-918007ca899c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-e6bc-736c-a288-918007ca899c",
        "storage_key": "property/6767906449165581/019cfb37-e6bc-736c-a288-918007ca899c.webp",
        "width": 1125,
        "height": 1280
      },
      "poi_business_url": "https://www.catalystbarberco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7880198162046748074&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "catalyst-barber-co---gladstone",
      "poi_latitude": "39.2255536",
      "poi_longitude": "-94.5755217",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-895-3006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b247-7010-b20c-b222fe20d541",
        "storage_key": "property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWyVmiCb3wIcRqoV7MHoWXG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_15e646e5-c766-46ec-b0a4-069c4bbcf9b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Bloom Nails & Spa North",
      "poi_type": "Health and Wellness",
      "poi_address": "422 NW Legacy Dr, Kansas City, MO 64155, USA",
      "poi_short_description": "Spacious nail spa featuring the option of a hot stone massage and steam treatment during a pedicure.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-e7ae-77cd-90d9-290dd5b7b362.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-e7ae-77cd-90d9-290dd5b7b362",
        "storage_key": "property/6767906449165581/019cfb37-e7ae-77cd-90d9-290dd5b7b362.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://bloomnailsandspakc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12966046450685814287&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bloom-nails--spa-north",
      "poi_latitude": "39.2498239",
      "poi_longitude": "-94.585128",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-429-5038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b247-7010-b20c-b222fe20d541",
        "storage_key": "property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8-MWYRpZwIcRD6ZXwoym8LM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_50a12994-0de1-4428-918c-a0d6980e5994",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Saint Luke's North Hospital-Barry Road",
      "poi_type": "Health and Wellness",
      "poi_address": "5830 NW Barry Rd, Kansas City, MO 64154, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-e832-76a7-a328-d2b9448cc34e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-e832-76a7-a328-d2b9448cc34e",
        "storage_key": "property/6767906449165581/019cfb37-e832-76a7-a328-d2b9448cc34e.webp",
        "width": 1280,
        "height": 928
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-north-hospital-barry-road?utm_source=yext&utm_medium=local_listing&utm_campaign=yext_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17032396065128644234&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-lukes-north-hospital-barry-road",
      "poi_latitude": "39.24887",
      "poi_longitude": "-94.6481735",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-891-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b24c-74b8-adf5-23a8aa6cdb7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b24c-74b8-adf5-23a8aa6cdb7c",
        "storage_key": "property/6767906449165581/019cfb37-b24c-74b8-adf5-23a8aa6cdb7c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJH88eiDVfwIcRiv7Az_o5X-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_3eedcdc7-ad85-43a5-a4f0-ec39ed1b0721",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Kindred Hospital Northland",
      "poi_type": "Health and Wellness",
      "poi_address": "500 NW 68th St, Kansas City, MO 64118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-e6d1-7104-afba-6799d657ba8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-e6d1-7104-afba-6799d657ba8b",
        "storage_key": "property/6767906449165581/019cfb37-e6d1-7104-afba-6799d657ba8b.webp",
        "width": 800,
        "height": 530
      },
      "poi_business_url": "https://www.kindredhospitals.com/locations/missouri/northland",
      "poi_directions_map_url": "https://maps.google.com/?cid=11634295283231026387&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kindred-hospital-northland",
      "poi_latitude": "39.2194532",
      "poi_longitude": "-94.5872855",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-420-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b24c-74b8-adf5-23a8aa6cdb7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b24c-74b8-adf5-23a8aa6cdb7c",
        "storage_key": "property/6767906449165581/019cfb37-b24c-74b8-adf5-23a8aa6cdb7c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bIxbcP3wIcR0-z8QOtRdaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_099432d0-ffaf-43b3-ba50-a5bd758df6f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Shoal Creek Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8905 Shoal Creek Pkwy, Kansas City, MO 64157, USA",
      "poi_short_description": "Public, par-71 course designed by Steve Wolfard featuring elevation changes and other challenges.",
      "poi_long_description": "People say this golf course is beautiful, challenging, and well-maintained. They highlight the course has a nice layout with interesting holes and ample-sized greens, and the fairways and tees are in good shape. They also like the friendly and professional staff, and the well-maintained carts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-aadb-73fe-82ea-be70ceea37a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-aadb-73fe-82ea-be70ceea37a0",
        "storage_key": "property/6767906449165581/019cfb37-aadb-73fe-82ea-be70ceea37a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://shoalcreekgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3060025617577092222&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "shoal-creek-golf-course",
      "poi_latitude": "39.2553169",
      "poi_longitude": "-94.4860135",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-407-7242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b22a-719d-92a1-31500e851f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b22a-719d-92a1-31500e851f86",
        "storage_key": "property/6767906449165581/019cfb37-b22a-719d-92a1-31500e851f86.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-QpC5wxWwIcRfiRHIxZldyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_3dc44369-e7f5-4aa3-ad9f-e3bd1f4eebc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Happy Rock Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7565 NE Antioch Rd, Gladstone, MO 64119, USA",
      "poi_short_description": "Clean park, known for its playgrounds and well-kept trails.",
      "poi_long_description": "Visitors say this park offers paved trails that are great for walking, jogging, and biking, as well as fields for playing soccer, baseball, and tennis. They also highlight the park's clean environment and peaceful atmosphere, making it an ideal spot for exercise and enjoying nature.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-e8dd-745d-b547-72dee6417c8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-e8dd-745d-b547-72dee6417c8d",
        "storage_key": "property/6767906449165581/019cfb37-e8dd-745d-b547-72dee6417c8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gladstone.mo.us/Recreation/parks.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=13819278990336049365&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "happy-rock-park",
      "poi_latitude": "39.230415",
      "poi_longitude": "-94.5345898",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-423-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b59b-7059-ac08-dbecb107dab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b59b-7059-ac08-dbecb107dab8",
        "storage_key": "property/6767906449165581/019cfb37-b59b-7059-ac08-dbecb107dab8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ52fxjtD5wIcR1cD_Jgbxx78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_110aa440-94eb-4b48-ac5b-6d243b5da4a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Tiffany Greens Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5900 NW Tiffany Springs Pkwy, Kansas City, MO 64154, USA",
      "poi_short_description": "Opened in 1999, this golf course with a pub & clubhouse offers lessons, tournaments & club fittings.",
      "poi_long_description": "People say this golf course offers a fun and challenging layout with split fairways and water hazards, and the staff is accommodating and helpful.\n\nOther reviews mention the course conditions can be poor and the greens can be rough.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-e8dd-745d-b547-6f05564dc958.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-e8dd-745d-b547-6f05564dc958",
        "storage_key": "property/6767906449165581/019cfb37-e8dd-745d-b547-6f05564dc958.webp",
        "width": 1000,
        "height": 692
      },
      "poi_business_url": "http://www.tiffanygreensgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18171086618110436744&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tiffany-greens-golf-club",
      "poi_latitude": "39.2742721",
      "poi_longitude": "-94.6459609",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-880-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b22a-719d-92a1-31500e851f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b22a-719d-92a1-31500e851f86",
        "storage_key": "property/6767906449165581/019cfb37-b22a-719d-92a1-31500e851f86.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJWYhuACpZwIcRiKVTLwGrLPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_63ab132d-ddc6-42fa-a6e9-92822879bd5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Hodge Park Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7000 NE Barry Rd, Kansas City, MO 64156, USA",
      "poi_short_description": "Wooded par-71 golf course with 3 lakes & a creek plus a driving range, pro shop & snack shop.",
      "poi_long_description": "People say this golf course offers a challenging layout with thick roughs and hilly terrain. They also highlight the reasonable rates, courteous staff, and the presence of wildlife.\n\nSome reviews mention the tee boxes can be rough.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-e8dd-745d-b547-6acd4b343811.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-e8dd-745d-b547-6acd4b343811",
        "storage_key": "property/6767906449165581/019cfb37-e8dd-745d-b547-6acd4b343811.webp",
        "width": 480,
        "height": 360
      },
      "poi_business_url": "http://www.hodgeparkgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17031190148626708500&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hodge-park-golf-course",
      "poi_latitude": "39.2506407",
      "poi_longitude": "-94.4979463",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-781-4152",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b22a-719d-92a1-31500e851f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b22a-719d-92a1-31500e851f86",
        "storage_key": "property/6767906449165581/019cfb37-b22a-719d-92a1-31500e851f86.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJpVBSnxVWwIcRFPgGfzTxWuw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_5c7480de-ab27-46e8-89bb-afc6061f0a69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Platte Purchase Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "N Platte Purchase Dr & NW 100 St, Kansas City, MO 64154, USA",
      "poi_short_description": "Athletic park with baseball fields and a playground, plus a walking trail.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-e927-723b-bf93-97fc8bfdb898.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-e927-723b-bf93-97fc8bfdb898",
        "storage_key": "property/6767906449165581/019cfb37-e927-723b-bf93-97fc8bfdb898.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://kcparks.org/places/platte-purchase-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9456642059924448902&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "platte-purchase-park",
      "poi_latitude": "39.2778579",
      "poi_longitude": "-94.608322",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b59b-7059-ac08-dbecb107dab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b59b-7059-ac08-dbecb107dab8",
        "storage_key": "property/6767906449165581/019cfb37-b59b-7059-ac08-dbecb107dab8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJybnH8wZZwIcRhqbQndm9PIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c00113b9-48fb-43f9-949a-eb1f56cf1887",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Kansas City Northern Knights R/C Airfield",
      "poi_type": "Transportation & Transit",
      "poi_address": "NE 96th St, Kansas City, MO 64157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-ae13-767e-9c43-c3e2ca6c50e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-ae13-767e-9c43-c3e2ca6c50e2",
        "storage_key": "property/6767906449165581/019cfb37-ae13-767e-9c43-c3e2ca6c50e2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.northernknights.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7305118864964463918&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kansas-city-northern-knights-rc-airfield",
      "poi_latitude": "39.26354329999999",
      "poi_longitude": "-94.496541",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b57e-746b-abbf-537ab1c08d5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b57e-746b-abbf-537ab1c08d5b",
        "storage_key": "property/6767906449165581/019cfb37-b57e-746b-abbf-537ab1c08d5b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJt0rUw2hWwIcRLi02TOf-YGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airstrip"
    },
    {
      "id": "custom_39824733-daf1-448e-8b3b-f03351d2f7a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Meta Data Center - Kansas City (KCM)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1800 NW 128 St, Kansas City, MO 64165, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6167808881323294431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "meta-data-center---kansas-city-kcm",
      "poi_latitude": "39.3248735",
      "poi_longitude": "-94.6009517",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-327-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b247-7010-b20c-b222fe20d541",
        "storage_key": "property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL503cQBbwIcR3z7GxX91mFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_58d9f5d6-64ff-44c4-9304-36f028604d8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Coperion",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7901 NW 107th Terrace, Kansas City, MO 64153, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-adec-76ab-b4bc-e6cb1eae9285.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-adec-76ab-b4bc-e6cb1eae9285",
        "storage_key": "property/6767906449165581/019cfb37-adec-76ab-b4bc-e6cb1eae9285.webp",
        "width": 1206,
        "height": 668
      },
      "poi_business_url": "http://www.coperion.com/fhn",
      "poi_directions_map_url": "https://maps.google.com/?cid=6747828070646791970&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "coperion",
      "poi_latitude": "39.2876007",
      "poi_longitude": "-94.6719577",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-891-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b247-7010-b20c-b222fe20d541",
        "storage_key": "property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_bckuxewIcRIr9P9OAZpV0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5d6ea3cc-23fb-48e5-8473-ae2f88796bf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Gladstone City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7010 N Holmes St, Gladstone, MO 64118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-ae07-75ff-a814-94ac5c0f6ee6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-ae07-75ff-a814-94ac5c0f6ee6",
        "storage_key": "property/6767906449165581/019cfb37-ae07-75ff-a814-94ac5c0f6ee6.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.gladstone.mo.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7875155584935402565&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gladstone-city-hall",
      "poi_latitude": "39.2214852",
      "poi_longitude": "-94.5718113",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-436-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b2df-7738-b3ca-97de3d7ee057.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b2df-7738-b3ca-97de3d7ee057",
        "storage_key": "property/6767906449165581/019cfb37-b2df-7738-b3ca-97de3d7ee057.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQZSlsPr3wIcRRRwCt0csSm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_f0dde570-ae72-4ae7-a57b-bf1d6d8436f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Truman Medical Center - Tiffany Springs Support Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7300 NW Tiffany Springs Pkwy, Kansas City, MO 64153, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-ae9e-711e-b777-63498c256b0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-ae9e-711e-b777-63498c256b0a",
        "storage_key": "property/6767906449165581/019cfb37-ae9e-711e-b777-63498c256b0a.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://www.trumed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13761603875370997946&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "truman-medical-center---tiffany-springs-support-center",
      "poi_latitude": "39.2732134",
      "poi_longitude": "-94.6630597",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-404-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b247-7010-b20c-b222fe20d541",
        "storage_key": "property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg6iBid5ewIcRupggA9AJ-74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_21e8a312-b310-4af5-9563-dfc3f74a9458",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Haldex Brake Products Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10930 N Pomona Ave, Kansas City, MO 64153, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.haldex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12009686585371356639&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haldex-brake-products-corporation",
      "poi_latitude": "39.2920401",
      "poi_longitude": "-94.6727477",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-643-2374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b247-7010-b20c-b222fe20d541",
        "storage_key": "property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcfi7p5NewIcR323VwFH6qqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0be42260-8c99-4518-8e82-0e3da5561dd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "New Mark Middle School",
      "poi_type": "Education",
      "poi_address": "NE 106th St, Kansas City, MO 64155, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://nmms.nkcschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4967047078139800144&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "new-mark-middle-school",
      "poi_latitude": "39.2851159",
      "poi_longitude": "-94.5721461",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-321-5290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b24a-751e-9929-3a537973210d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b24a-751e-9929-3a537973210d",
        "storage_key": "property/6767906449165581/019cfb37-b24a-751e-9929-3a537973210d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxa_jUQBZwIcRUCoqQwB_7kQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_2808da95-ec87-4e56-938d-e7322f883575",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Fox Hill Elementary School",
      "poi_type": "Education",
      "poi_address": "545 NE 106th St, Kansas City, MO 64155, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://fhes.nkcschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9471517950524041843&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fox-hill-elementary-school",
      "poi_latitude": "39.2848147",
      "poi_longitude": "-94.569255",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-321-5090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b24a-751e-9929-3a537973210d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b24a-751e-9929-3a537973210d",
        "storage_key": "property/6767906449165581/019cfb37-b24a-751e-9929-3a537973210d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcVjDVG9XwIcRc6q4zGSXcYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6322dd43-1c9d-4dbf-b248-ee2dd4d5483f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "UMKC School of Dentistry",
      "poi_type": "Education",
      "poi_address": "650 E 25th St, Kansas City, MO 64108, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-aad0-755f-ab56-7c19895e51ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-aad0-755f-ab56-7c19895e51ca",
        "storage_key": "property/6767906449165581/019d7911-aad0-755f-ab56-7c19895e51ca.webp",
        "width": 1280,
        "height": 658
      },
      "poi_business_url": "http://dentistry.umkc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2676145397732226987&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "umkc-school-of-dentistry",
      "poi_latitude": "39.0820446",
      "poi_longitude": "-94.5770394",
      "poi_miles_from_property": "15.0 mi",
      "poi_walking_minutes": "5 hours 38 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 816-235-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b24a-751e-9929-3a537973210d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b24a-751e-9929-3a537973210d",
        "storage_key": "property/6767906449165581/019cfb37-b24a-751e-9929-3a537973210d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ-HXkxPwwIcRqzcgdw-UIyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_d1cfaa1e-67f0-4f05-81b4-9a2bfaaacfae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Kansas City University",
      "poi_type": "Education",
      "poi_address": "1750 Independence Ave, Kansas City, MO 64106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-aa0e-772f-bb68-5de95a9a7d4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-aa0e-772f-bb68-5de95a9a7d4b",
        "storage_key": "property/6767906449165581/019d7911-aa0e-772f-bb68-5de95a9a7d4b.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "http://kansascity.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16389816158537025495&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kansas-city-university",
      "poi_latitude": "39.1072822",
      "poi_longitude": "-94.5609759",
      "poi_miles_from_property": "14.0 mi",
      "poi_walking_minutes": "5 hours 13 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 816-654-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b24a-751e-9929-3a537973210d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b24a-751e-9929-3a537973210d",
        "storage_key": "property/6767906449165581/019cfb37-b24a-751e-9929-3a537973210d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg1greoD6wIcR14eOj_VSdOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9298fda8-6a24-4b2e-953e-9fdbdea6fd2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Staley High School",
      "poi_type": "Education",
      "poi_address": "2800 NE Shoal Creek Pkwy, Kansas City, MO 64156, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-abf7-74af-a0f9-728a79f10bf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-abf7-74af-a0f9-728a79f10bf5",
        "storage_key": "property/6767906449165581/019d7911-abf7-74af-a0f9-728a79f10bf5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sths.nkcschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1903684922458480890&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "staley-high-school",
      "poi_latitude": "39.2883141",
      "poi_longitude": "-94.5438524",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-321-5330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b24a-751e-9929-3a537973210d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b24a-751e-9929-3a537973210d",
        "storage_key": "property/6767906449165581/019cfb37-b24a-751e-9929-3a537973210d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcVjDVG9XwIcR-qBnz1k_axo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_7d957aa7-f5e7-492d-8beb-4d0d59ff4c89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Jimmy John's",
      "poi_type": "Restaurants",
      "poi_address": "9558 N McGee St, Kansas City, MO 64155, USA",
      "poi_short_description": "Counter-serve chain specializing in sub & club sandwiches, plus signature potato chips.",
      "poi_long_description": "People say this sandwich shop offers fresh and tasty sandwiches.\n\nOther reviews mention the service can be slow and the staff can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-ab6c-728e-b317-18604c471e4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ab6c-728e-b317-18604c471e4f",
        "storage_key": "property/6767906449165581/019d7911-ab6c-728e-b317-18604c471e4f.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://locations.jimmyjohns.com/mo/kansascity/sandwiches-1341.html?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAyNDA4MzQwNi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4266625378143563925&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jimmy-john-s",
      "poi_latitude": "39.265889",
      "poi_longitude": "-94.5774024",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-468-8383",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b2dd-71c0-a39e-557f679d06da",
        "storage_key": "property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZzgQM9ZwIcRlfDpBS0ZNjs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_f14cb848-e981-42cc-a1c8-8fc36184520c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "8420 N Madison Ave, Kansas City, MO 64155, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-b2d1-7248-b805-3ef5af729475.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b2d1-7248-b805-3ef5af729475",
        "storage_key": "property/6767906449165581/019d7911-b2d1-7248-b805-3ef5af729475.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/88963",
      "poi_directions_map_url": "https://maps.google.com/?cid=14258906151341082230&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "39.24876",
      "poi_longitude": "-94.59559",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-436-8711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-f657-72af-b425-b8426e45f5df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7911-f657-72af-b425-b8426e45f5df",
        "storage_key": "property/6767906449165581/019d7911-f657-72af-b425-b8426e45f5df.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJkavVLWZYwIcRdkZRBJnP4cU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_c725a3fb-642b-45ce-a73b-70596e801625",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Red Wok",
      "poi_type": "Restaurants",
      "poi_address": "9322 N Oak Trafficway, Kansas City, MO 64155, USA",
      "poi_short_description": "Casual Chinese eatery offering a large menu of familiar appetizers & entrees, plus lunch specials.",
      "poi_long_description": "People say this Chinese restaurant serves delicious dishes like General Tso's chicken, lo mein, and crab rangoon. They also highlight the generous portions, quick service, and friendly staff.\n\nOther reviews mention the rice can be mushy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-b993-7508-8502-27a96a0160ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b993-7508-8502-27a96a0160ac",
        "storage_key": "property/6767906449165581/019d7911-b993-7508-8502-27a96a0160ac.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.redwokcr.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=838358078885552279&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "red-wok",
      "poi_latitude": "39.2632486",
      "poi_longitude": "-94.5773547",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-468-8868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b2dd-71c0-a39e-557f679d06da",
        "storage_key": "property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_6_dtzBYwIcRl2CNHjtyogs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_5c5dc68f-11af-4433-8553-9da98dc2f50a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Sonic Drive-In",
      "poi_type": "Restaurants",
      "poi_address": "301 NE 91 St, Kansas City, MO 64155, USA",
      "poi_short_description": "Fast-food burger & fries joint with an old-school feel, including retro drive-in service.",
      "poi_long_description": "People say this fast food restaurant offers a variety of burgers, hot dogs, ice cream, and snacks, and has a convenient drive-thru.\n\nOther reviews mention the service can be impolite and the food can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-b67c-7701-aba9-5f47e0fe1d61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b67c-7701-aba9-5f47e0fe1d61",
        "storage_key": "property/6767906449165581/019d7911-b67c-7701-aba9-5f47e0fe1d61.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://www.sonicdrivein.com/locations/us/mo/kansas-city/301-ne-91st/store-6426?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAzMzg1OTE5OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2832603223431334330&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sonic-drive-in",
      "poi_latitude": "39.25867909999999",
      "poi_longitude": "-94.5766896",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-468-1999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b2dd-71c0-a39e-557f679d06da",
        "storage_key": "property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWTL0xztYwIcRuklAup9tTyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_a51b1321-5be2-4b74-82a7-38bdc0dfafd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Smoothie King",
      "poi_type": "Restaurants",
      "poi_address": "462 NE Barry Rd, Kansas City, MO 64155, USA",
      "poi_short_description": "Health-conscious chain featuring blended drinks in varied flavors with fruits & veggies.",
      "poi_long_description": "People say this juice shop offers a variety of smoothies, including meal replacement options and protein boosts. They also highlight the friendly and apologetic staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-b676-7178-b02c-e9dfe6fa8e67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b676-7178-b02c-e9dfe6fa8e67",
        "storage_key": "property/6767906449165581/019d7911-b676-7178-b02c-e9dfe6fa8e67.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.smoothieking.com/ll/us/mo/kansas-city/462-ne-barry-rd?utm_source=google&utm_medium=organic&utm_content=SOCi",
      "poi_directions_map_url": "https://maps.google.com/?cid=14055899715721006745&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "smoothie-king",
      "poi_latitude": "39.2486887",
      "poi_longitude": "-94.5742698",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-437-7175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b2dd-71c0-a39e-557f679d06da",
        "storage_key": "property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGXbOX6ZZwIcRmY4Q8lGWEMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "juice_shop"
    },
    {
      "id": "custom_37f17562-ae4e-44cf-bfb8-ac9f4c3daa19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Hawaiian Bros Island Grill",
      "poi_type": "Restaurants",
      "poi_address": "700 NW Barry Rd, Kansas City, MO 64155, USA",
      "poi_short_description": "Chain eatery with a drive-thru offering Hawaiian specialties, including huli huli chicken, and Dole Whip.",
      "poi_long_description": "People say this Hawaiian restaurant serves delicious chicken, pork, and spam musubi, with tasty sides like rice and macaroni salad. They highlight the generous portions, good value, and fresh, hot food that makes amazing leftovers. They also like the friendly staff, fast service, and clean, happy atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-c010-77e6-8f85-169efdfda91e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c010-77e6-8f85-169efdfda91e",
        "storage_key": "property/6767906449165581/019d7911-c010-77e6-8f85-169efdfda91e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://hawaiianbros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9212220883796328837&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hawaiian-bros-island-grill",
      "poi_latitude": "39.2471319",
      "poi_longitude": "-94.5892757",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-455-9468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b2dd-71c0-a39e-557f679d06da",
        "storage_key": "property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkzwIMrJZwIcRhYEd2xVi2H8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hawaiian_restaurant"
    },
    {
      "id": "custom_fcaea7ef-3273-4aa3-852a-fa1920ae837a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "500 NW Barry Rd, Kansas City, MO 64155, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Diners say this Italian restaurant serves up tasty breadsticks, soup, and flavorful pasta dishes. They also highlight the friendly and attentive staff, and the warm and welcoming atmosphere.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-c4c3-772c-943f-4d6bbf4e2c50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c4c3-772c-943f-4d6bbf4e2c50",
        "storage_key": "property/6767906449165581/019d7911-c4c3-772c-943f-4d6bbf4e2c50.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.olivegarden.com/locations/mo/kansas-city/kansas-city-north-barry-road/1170?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:kansas-city-mo-1170_pl:locurl_rd:1120",
      "poi_directions_map_url": "https://maps.google.com/?cid=3382930713511415223&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "39.24691",
      "poi_longitude": "-94.586687",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-468-7540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b2dd-71c0-a39e-557f679d06da",
        "storage_key": "property/6767906449165581/019cfb37-b2dd-71c0-a39e-557f679d06da.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9cgfgmtYwIcRt02bdo-V8i4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_8b1d4e5c-4bab-453a-9374-5a06507f4caa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Liberty Corners",
      "poi_type": "Shopping & Retail",
      "poi_address": "840-916 Rte 291, Liberty, MO 64068, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-c6c0-71fa-94ec-568c0617396c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c6c0-71fa-94ec-568c0617396c",
        "storage_key": "property/6767906449165581/019d7911-c6c0-71fa-94ec-568c0617396c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://properties.brixmor.com/p/retail-real-estate/Liberty-MO-64068-2296/libertycorners?utm_source=gmb&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=2503774602066161541&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "liberty-corners",
      "poi_latitude": "39.2358422",
      "poi_longitude": "-94.435947",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 610-215-7939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b24f-7589-bb27-8b73388a0919.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b24f-7589-bb27-8b73388a0919",
        "storage_key": "property/6767906449165581/019cfb37-b24f-7589-bb27-8b73388a0919.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJeWA5GX5VwIcRhW_MKbwxvyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_728b046b-659e-4d08-9219-193a90b3800d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "River Bluff Brewing at River Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "201 Main St Ste 101, Kansas City, MO 64105, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-c77d-739f-8dd5-07aab219f050.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c77d-739f-8dd5-07aab219f050",
        "storage_key": "property/6767906449165581/019d7911-c77d-739f-8dd5-07aab219f050.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "http://riverbluffbrew.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1454812479848957469&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "river-bluff-brewing-at-river-market",
      "poi_latitude": "39.1107025",
      "poi_longitude": "-94.5831451",
      "poi_miles_from_property": "13.2 mi",
      "poi_walking_minutes": "4 hours 55 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 816-255-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b247-7010-b20c-b222fe20d541",
        "storage_key": "property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHf2YBEPxwIcRHcYzFD6IMBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_95d38495-81ac-459d-8fb3-d92932399805",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Barrywoods Crossing",
      "poi_type": "Shopping & Retail",
      "poi_address": "8121 NW Roanridge Rd., Kansas City, MO 64154, USA",
      "poi_short_description": "Shopping mall cinema with IMAX and recliners, plus Indian films.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-cd3a-75dc-9057-b8ff585f1aa5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-cd3a-75dc-9057-b8ff585f1aa5",
        "storage_key": "property/6767906449165581/019d7911-cd3a-75dc-9057-b8ff585f1aa5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2115509129970691528&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "barrywoods-crossing",
      "poi_latitude": "39.2465891",
      "poi_longitude": "-94.6552534",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 407-378-2486",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b24f-7589-bb27-8b73388a0919.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b24f-7589-bb27-8b73388a0919",
        "storage_key": "property/6767906449165581/019cfb37-b24f-7589-bb27-8b73388a0919.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJN-NR5EZfwIcRyK3_YljMWx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f641baf7-b3a0-4535-bc35-f28d0c14620b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Zona Rosa",
      "poi_type": "Shopping & Retail",
      "poi_address": "8640 N Dixson Ave, Kansas City, MO 64153, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this shopping center offers a wide variety of shops and restaurants, including a popular bookstore and comedy club, with a family-friendly atmosphere featuring a splash pad and playground. They also highlight the clean and well-maintained environment, diverse shopping options, and convenient parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-d29d-73d9-9998-8816e72735d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d29d-73d9-9998-8816e72735d6",
        "storage_key": "property/6767906449165581/019d7911-d29d-73d9-9998-8816e72735d6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.zonarosa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5951982250480702551&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "zona-rosa",
      "poi_latitude": "39.2504629",
      "poi_longitude": "-94.6634203",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b24f-7589-bb27-8b73388a0919.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b24f-7589-bb27-8b73388a0919",
        "storage_key": "property/6767906449165581/019cfb37-b24f-7589-bb27-8b73388a0919.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1Xi4_SRfwIcRVxRVZVKwmVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c44b6527-e1f0-4cf4-9d3e-0ce225c70601",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "1600 NW 88th St, Kansas City, MO 64155, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Shoppers say this warehouse store offers a great selection of produce, meat, and gluten-free items, as well as quality organic foods in bulk at reasonable prices. They also highlight the friendly and helpful staff, and the clean and well-maintained store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-d280-7489-8ec4-b42f3719c1a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d280-7489-8ec4-b42f3719c1a8",
        "storage_key": "property/6767906449165581/019d7911-d280-7489-8ec4-b42f3719c1a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/kansas-city-MO-1268.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=4790425980030826484&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "39.2550295",
      "poi_longitude": "-94.5984984",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-857-7086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b24f-7589-bb27-8b73388a0919.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b24f-7589-bb27-8b73388a0919",
        "storage_key": "property/6767906449165581/019cfb37-b24f-7589-bb27-8b73388a0919.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJATPVmV5YwIcR9DeKTgwDe0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_3220ca61-7e07-41ef-bf25-50e4f29f86b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Penguin Park",
      "poi_type": "Entertainment",
      "poi_address": "4124 NE Vivion Rd, Kansas City, MO 64119, USA",
      "poi_short_description": "Whimsical public park featuring giant animal sculptures, a picnic shelter & barbecue grills.",
      "poi_long_description": "People say this city park offers a variety of playground equipment, including slides, swings, and climbing structures, as well as a walking trail and picnic area. They highlight the clean restrooms, free parking, and covered area for weather changes. They also like the unique penguin theme and the easy visibility of children from most vantage points.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-d6b5-7219-b6d2-04ff1055de3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d6b5-7219-b6d2-04ff1055de3d",
        "storage_key": "property/6767906449165581/019d7911-d6b5-7219-b6d2-04ff1055de3d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kcparks.org/park/penguin-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17185212368197134391&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "penguin-park",
      "poi_latitude": "39.1875038",
      "poi_longitude": "-94.5310444",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b59b-7059-ac08-dbecb107dab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b59b-7059-ac08-dbecb107dab8",
        "storage_key": "property/6767906449165581/019cfb37-b59b-7059-ac08-dbecb107dab8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJn4kx8635wIcRNygKBJkjfu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_fdcae153-d5a2-43a0-8394-b0ba809ab696",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "B&B KC Northland 14",
      "poi_type": "Entertainment",
      "poi_address": "4900 NE 80th St, Kansas City, MO 64119, USA",
      "poi_short_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_long_description": "People say this movie theater offers comfortable reclining seats and a great movie experience. They also highlight the friendly staff and clean facilities.\n\nOther reviews mention the snacks can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-dac1-740a-8c7d-31e953920ea3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-dac1-740a-8c7d-31e953920ea3",
        "storage_key": "property/6767906449165581/019d7911-dac1-740a-8c7d-31e953920ea3.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.bbtheatres.com/our-theatres/x0uvg-b-and-b-kc-northland/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17679910262764140181&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "b-b-kc-northland-14",
      "poi_latitude": "39.239301",
      "poi_longitude": "-94.5225626",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-468-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-f7a0-73f4-9970-530e66421442.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7911-f7a0-73f4-9970-530e66421442",
        "storage_key": "property/6767906449165581/019d7911-f7a0-73f4-9970-530e66421442.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJodA5FNNXwIcRlfbWOLaoW_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_9ce66c50-b53a-4666-9b88-bb22da39a531",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "PowerPlay Metro North Entertainment Center",
      "poi_type": "Entertainment",
      "poi_address": "509 NW Barry Rd, Kansas City, MO 64155, USA",
      "poi_short_description": "Indoor venue with arcade games, a carousel & other kiddie rides, plus laser tag & outdoor go karts.",
      "poi_long_description": "Visitors say this video arcade offers go-karts, a roller coaster, and laser tag, and they appreciate the friendly and helpful staff. They also highlight the fun atmosphere for kids and adults alike, with many mentioning the go-karts as a popular attraction.\n\nSome reviews mention many of the arcade games can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-e6d2-76ec-b9f8-e9ba71c75fcb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e6d2-76ec-b9f8-e9ba71c75fcb",
        "storage_key": "property/6767906449165581/019d7911-e6d2-76ec-b9f8-e9ba71c75fcb.webp",
        "width": 819,
        "height": 461
      },
      "poi_business_url": "https://www.powerplaykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9237776349679560047&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "powerplay-metro-north-entertainment-center",
      "poi_latitude": "39.2444458",
      "poi_longitude": "-94.58815",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-423-4447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b247-7010-b20c-b222fe20d541",
        "storage_key": "property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM-mRIGxYwIcRb6UnbaUsM4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "video_arcade"
    },
    {
      "id": "custom_d33dcef7-3fd7-4a3c-b001-81c60b8b4da1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Bally’s Kansas City Casino",
      "poi_type": "Entertainment",
      "poi_address": "1800 E Front St, Kansas City, MO 64120, USA",
      "poi_short_description": "Casino chain featuring slots, video poker, table games & dining, plus meeting space.",
      "poi_long_description": "People say this casino offers a wide variety of slot machines and table games, and has a fun, lively atmosphere.\n\nOther reviews mention the payouts can be low and the machines can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d7911-ebaf-72de-b01c-b75b03bc712f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ebaf-72de-b01c-b75b03bc712f",
        "storage_key": "property/6767906449165581/019d7911-ebaf-72de-b01c-b75b03bc712f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ballyskansascity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2899852266921797158&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bally-s-kansas-city-casino",
      "poi_latitude": "39.1215135",
      "poi_longitude": "-94.5620959",
      "poi_miles_from_property": "13.5 mi",
      "poi_walking_minutes": "4 hours 57 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 816-855-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-b247-7010-b20c-b222fe20d541",
        "storage_key": "property/6767906449165581/019cfb37-b247-7010-b20c-b222fe20d541.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp5JYjp3wwIcRJib8zkVYPig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_1a208c1e-80f3-421e-8904-7e8bed394286",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "poi_name": "Northland Innovation Center – Northwest Missouri State University",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "northland-innovation-center-northwest-missouri-state-university",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_e560413a9e11863043ab5bcb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6e753906c53b33ff53ebbba1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0d60e19ec3cea9ff9f8a40c5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_40d02232c9a2e94bc7a06175",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_2b953ea1289f877d51bee469",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_e6584b26c07f0951edfd9fa3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [],
  "virtual_tours": [
    {
      "id": "custom_1bd9889c-026e-4c5d-a7f0-5463d724a576",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb38-790e-779f-ab26-072595dacb0e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of the leasing office and lounge area.",
        "public_id": "019cfb38-790e-779f-ab26-072595dacb0e",
        "storage_key": "property/6767906449165581/019cfb38-790e-779f-ab26-072595dacb0e.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "97@ North Oak Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=628015d38b5f9641d1cf09e1"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199eb68-7f9b-737d-b3ff-29d184a78de4",
      "lead_source": "LANDING_PAGE",
      "name": "case-and-associates-97-at-north-oak",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581"
    },
    {
      "lead_collector_id": "019cf784-63e3-7554-8827-e82a629c641e",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "97 at North Oak Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "generator",
      "page_item_url": "97-at-north-oak-luxury-apartments-with-pool-kansas-city",
      "search_query": "luxury apartments with pool Kansas City",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Kansas City",
      "h2_subtitle": "Discover premier luxury apartments with a pool in Kansas City. Experience the best of comfort and style at 97 at North Oak.",
      "page_copy": "Welcome to 97 at North Oak, your go-to destination for luxury apartments with pool access in Kansas City. Our community is not just about making a home; it's about living the dream. Dive into our refreshing pool and unwind after a busy day or simply lounge by the cabana. At 97 at North Oak, our amenities are designed to complement your lifestyle, offering the perfect blend of relaxation and activity. Whether you choose a one, two, or three-bedroom apartment, each features high ceilings and access to top-notch facilities.<br><br>Located in the vibrant Meadowbrook Heights neighborhood, our luxury apartments provide high-speed internet access and a concierge service to meet your every need. Take a tour and discover why our pool is just one of the many highlights at 97 at North Oak. Experience a community where luxury meets convenience in the heart of Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, accent chair, coffee table, and desk with painting above.",
        "public_id": "019cfb37-800d-750a-8001-6eb4af71584b",
        "storage_key": "property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Kansas City",
      "seo_description": "Discover luxury apartments with a pool in Kansas City at 97 at North Oak. Enjoy high-end amenities and a vibrant community. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "generator",
      "page_item_url": "97-at-north-oak-pet-friendly-apartments-with-dog-park-missouri",
      "search_query": "pet friendly apartments with dog park Missouri",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park in MO",
      "h2_subtitle": "Explore pet-friendly apartments featuring a dog park in Missouri. Perfect for you and your furry friends at 97 at North Oak.",
      "page_copy": "Discover the ideal pet-friendly apartments with a dog park in Missouri at 97 at North Oak, located in Kansas City. Our community goes beyond just welcoming pets—we provide a dedicated pet play area where your furry friends can run and play. Our spacious one, two, and three-bedroom apartments feature high ceilings and thoughtful details, ensuring both you and your pets enjoy a comfortable lifestyle.<br><br>Situated in Meadowbrook Heights, we offer a unique blend of luxury and care for pet owners. Besides the pet play area, residents enjoy a suite of top-tier amenities, including a fitness center, high-speed internet access, and a concierge service tailored to meet your needs. Schedule a visit today to see why 97 at North Oak is the perfect choice for you and your pets to call home in Missouri.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, accent chair, coffee table, and desk with painting above.",
        "public_id": "019cfb37-800d-750a-8001-6eb4af71584b",
        "storage_key": "property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Park in MO",
      "seo_description": "Find pet-friendly apartments with a dog park in Missouri at 97 at North Oak. Ideal for you and your pets in vibrant Kansas City. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "generator",
      "page_item_url": "97-at-north-oak-apartments-with-air-conditioning-meadowbrook-heights",
      "search_query": "apartments with air conditioning in Meadowbrook Heights",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in Meadowbrook",
      "h2_subtitle": "Stay cool with air-conditioned apartments in Meadowbrook Heights. Discover comfort and convenience at 97 at North Oak.",
      "page_copy": "Enjoy all the comforts of home with our air-conditioned apartments in Meadowbrook Heights, exclusively at 97 at North Oak in Kansas City. Offering one, two, and three-bedroom layouts, each apartment is designed with your comfort in mind, featuring high ceilings and effective air conditioning for those hot summer days.<br><br>Located in the charming neighborhood of Meadowbrook Heights, our community invites you to explore a lifestyle of ease and luxury. Our residents enjoy a variety of amenities, including a refreshing pool, a modern fitness center, and cabanas for a relaxing retreat. Come and tour our property today to see how our air-conditioned apartments can enhance your living experience in Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, accent chair, coffee table, and desk with painting above.",
        "public_id": "019cfb37-800d-750a-8001-6eb4af71584b",
        "storage_key": "property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments in Meadowbrook Heights",
      "seo_description": "Find comfortable air-conditioned apartments in Meadowbrook Heights at 97 at North Oak. Convenient, cool, and perfect for Kansas City living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "generator",
      "page_item_url": "97-at-north-oak-kansas-city-apartments-with-in-unit-washer-dryer",
      "search_query": "Kansas City apartments with in unit washer dryer",
      "category": "Amenity",
      "h1_title": "KC Apartments with In-Unit Washer & Dryer",
      "h2_subtitle": "Find Kansas City apartments offering in-unit washer and dryer. Experience hassle-free living at 97 at North Oak.",
      "page_copy": "Welcome to 97 at North Oak, offering Kansas City apartments equipped with the convenience of in-unit washers and dryers. Our spacious one, two, and three-bedroom apartments are designed to simplify your lifestyle, providing everything you need under one roof. Say goodbye to laundry day hassles and embrace more leisure time with these modern conveniences.<br><br>Nestled in the lively Meadowbrook Heights area, our community enhances daily living with luxurious amenities like a sparkling pool, a fully-equipped fitness center, and high-speed internet access. Perfect your living experience in Kansas City with our dedicated concierge service ready to cater to your needs. Arrange a tour today to discover the seamless blend of comfort and convenience that awaits you at 97 at North Oak.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, accent chair, coffee table, and desk with painting above.",
        "public_id": "019cfb37-800d-750a-8001-6eb4af71584b",
        "storage_key": "property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "KC Apartments with In-Unit Washer & Dryer",
      "seo_description": "Discover Kansas City apartments with in-unit washer and dryer at 97 at North Oak. Enjoy luxury and convenience in vibrant Meadowbrook Heights.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "generator",
      "page_item_url": "97-at-north-oak-apartments-with-fitness-center-in-64155",
      "search_query": "apartments with fitness center in 64155",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in 64155",
      "h2_subtitle": "Explore apartments featuring a fitness center in the 64155 area. Stay active and healthy at 97 at North Oak.",
      "page_copy": "At 97 at North Oak, we offer premium apartments with a state-of-the-art fitness center in the 64155 area code of Kansas City. Designed for those who value health and wellness, our community ensures you have immediate access to top-notch fitness facilities. Choose from spacious one, two, or three-bedroom floor plans, each combining style with functionality.<br><br>Our location in Meadowbrook Heights is perfect for those who seek a well-rounded lifestyle. In addition to the fitness center, residents enjoy benefits such as a refreshing pool and relaxing cabanas, ideal for post-workout relaxation, as well as concierge services for added convenience. Experience the best of Kansas City living by scheduling a visit to 97 at North Oak today, where health and home converge beautifully.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, accent chair, coffee table, and desk with painting above.",
        "public_id": "019cfb37-800d-750a-8001-6eb4af71584b",
        "storage_key": "property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "64155 Apartments with Fitness Center",
      "seo_description": "Discover apartments in 64155 with a fitness center at 97 at North Oak. Enjoy active living with premium amenities in Kansas City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "generator",
      "page_item_url": "97-at-north-oak-one-bedroom-apartments-kansas-city-mo",
      "search_query": "one bedroom apartments kansas city mo",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Kansas City, MO",
      "h2_subtitle": "Discover spacious one-bedroom apartments in Kansas City, MO. Welcome home to 97 at North Oak.",
      "page_copy": "Find your new home in the one-bedroom apartments at 97 at North Oak, ideally situated in Kansas City, MO. Our thoughtfully designed floor plans boast high ceilings and spacious interiors, perfectly balancing comfort with style. Whether you're looking for a cozy retreat or room to entertain, our one-bedroom options provide the perfect setting.<br><br>Located in the vibrant Meadowbrook Heights neighborhood, 97 at North Oak enhances your living experience with luxurious community amenities. Enjoy a refreshing dip in our pool, take advantage of the pet play area, or unwind in our elegant courtyard. With high-speed internet and concierge services, convenience is at your fingertips. Visit us to explore the perfect one-bedroom apartment that meets your needs in Kansas City, MO.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, accent chair, coffee table, and desk with painting above.",
        "public_id": "019cfb37-800d-750a-8001-6eb4af71584b",
        "storage_key": "property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Kansas City, MO",
      "seo_description": "Explore one-bedroom apartments in Kansas City, MO at 97 at North Oak, offering comfort and modern amenities in Meadowbrook Heights.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "generator",
      "page_item_url": "97-at-north-oak-two-bedroom-rentals-in-meadowbrook-heights",
      "search_query": "two bedroom rentals in meadowbrook heights",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Rentals in Meadowbrook Heights",
      "h2_subtitle": "Discover spacious two-bedroom rentals in Meadowbrook Heights. Experience luxury at 97 at North Oak.",
      "page_copy": "Welcome to 97 at North Oak, where our two-bedroom rentals in the Meadowbrook Heights area offer the ideal blend of comfort and modern design. These well-appointed apartments feature open layouts with high ceilings, providing an inviting space for you and your loved ones. Each unit is designed to enhance your lifestyle, offering ample room for both living and entertaining.<br><br>Located in the heart of Meadowbrook Heights, our community provides access to exceptional amenities like a sparkling pool, a fully-equipped fitness center, and a convenient pet play area. Enjoy high-speed internet access throughout the complex as well as personalized service from our concierge. Experience living in a community that prioritizes both luxury and convenience. Contact us today to tour our two-bedroom rentals at 97 at North Oak.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, accent chair, coffee table, and desk with painting above.",
        "public_id": "019cfb37-800d-750a-8001-6eb4af71584b",
        "storage_key": "property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Rentals in Meadowbrook Heights",
      "seo_description": "Find two-bedroom rentals in Meadowbrook Heights at 97 at North Oak, offering spacious layouts and premium amenities in a thriving community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "generator",
      "page_item_url": "97-at-north-oak-3-bedroom-apartment-floor-plans-64155",
      "search_query": "3 bedroom apartment floor plans 64155",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartment Floor Plans in 64155",
      "h2_subtitle": "Explore expansive 3-bedroom apartment floor plans in the 64155 area. Ideal for families at 97 at North Oak.",
      "page_copy": "Discover the perfect family living space with our 3-bedroom apartment floor plans located in the desirable 64155 area at 97 at North Oak. Our spacious layouts provide ample room for growing families, home offices, or additional guests, making them ideal for modern living. Each apartment is thoughtfully designed with high ceilings and quality finishes to create a comfortable and inviting atmosphere.<br><br>Situated in the charming Meadowbrook Heights neighborhood of Kansas City, these apartments boast access to exceptional amenities including a refreshing pool, a fitness center, and a pet play area, offering a well-rounded lifestyle. High-speed internet access keeps you connected, while our concierge is always at hand to assist with your needs. Visit us today to explore the ideal 3-bedroom apartment floor plan that fits your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, accent chair, coffee table, and desk with painting above.",
        "public_id": "019cfb37-800d-750a-8001-6eb4af71584b",
        "storage_key": "property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Floor Plans in 64155",
      "seo_description": "Discover 3-bedroom apartment floor plans in 64155 at 97 at North Oak, offering spacious designs and family-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "generator",
      "page_item_url": "97-at-north-oak-apartments-near-maple-woods",
      "search_query": "apartments near metropolitan community college maple woods kansas city",
      "category": "School",
      "h1_title": "Apartments Near Maple Woods in Kansas City",
      "h2_subtitle": "Find convenient apartments near Metropolitan Community College Maple Woods in Kansas City at 97 at North Oak.",
      "page_copy": "Welcome to 97 at North Oak, your home just a short distance from the Metropolitan Community College Maple Woods in Kansas City. Our community features a variety of spacious floor plans, ensuring you find the perfect one or two-bedroom apartment that aligns with your needs. Enjoy the modern conveniences and luxurious touches that make our community a standout choice for students and professionals alike.<br><br>Nestled in the picturesque Meadowbrook Heights neighborhood, our apartments offer seamless commutes to Maple Woods and beyond, thanks to excellent transport links. Dive into the relaxing pool after a long day, stay active at our on-site fitness center, or enjoy quiet moments in our landscaped courtyard. Experience high-speed internet and exemplary concierge service, all designed to enhance your living experience near Maple Woods.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, accent chair, coffee table, and desk with painting above.",
        "public_id": "019cfb37-800d-750a-8001-6eb4af71584b",
        "storage_key": "property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Maple Woods, Kansas City",
      "seo_description": "Explore apartments near Metropolitan Community College Maple Woods in Kansas City at 97 at North Oak, offering convenient commutes and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "generator",
      "page_item_url": "97-at-north-oak-apartments-near-saint-lukes-north",
      "search_query": "apartments near saint luke's north hospital kansas city",
      "category": "Hospital",
      "h1_title": "Apartments Near Saint Luke's North Hospital",
      "h2_subtitle": "Explore comfortable apartments near Saint Luke's North Hospital in Kansas City at 97 at North Oak.",
      "page_copy": "Discover the perfect living space at 97 at North Oak, ideally situated near Saint Luke's North Hospital in Kansas City. Our modern community offers an array of apartment options, including one, two, and three-bedroom floor plans, designed to meet diverse needs. Whether you're a healthcare professional or simply seeking proximity to quality medical facilities, our apartments provide the ideal mix of convenience and comfort.<br><br>Located in the tranquil Meadowbrook Heights neighborhood, our community features premium amenities such as a refreshing swimming pool, a well-equipped fitness center, and a welcoming pet play area. High-speed internet access and a dedicated concierge ensure that your daily needs are met with ease. Experience the best of Kansas City living with a home close to both work and leisure at 97 at North Oak.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, accent chair, coffee table, and desk with painting above.",
        "public_id": "019cfb37-800d-750a-8001-6eb4af71584b",
        "storage_key": "property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Saint Luke's North Hospital",
      "seo_description": "Find well-appointed apartments near Saint Luke's North Hospital in Kansas City at 97 at North Oak, offering modern amenities and spacious living options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "generator",
      "page_item_url": "97-at-north-oak-apartments-close-to-kindred-hospital",
      "search_query": "apartments close to kindred hospital northland meadowbrook heights",
      "category": "Hospital",
      "h1_title": "Apartments Close to Kindred Hospital Northland",
      "h2_subtitle": "Discover apartments close to Kindred Hospital Northland in the Meadowbrook Heights area at 97 at North Oak.",
      "page_copy": "Welcome to 97 at North Oak, where convenience meets comfort just minutes from Kindred Hospital Northland in the charming neighborhood of Meadowbrook Heights. We offer a variety of apartment layouts, including spacious one, two, and three-bedroom options, perfect for anyone looking to live near the hospital without compromising on lifestyle amenities.<br><br>Our community not only provides close proximity to healthcare facilities but also surrounds you with upscale features such as a luxurious pool, a modern fitness center, and a relaxing courtyard. Enjoy high-speed internet and concierge services essential for a hassle-free living experience. Choose 97 at North Oak for a home that prioritizes both convenience and a sense of community right here in Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, accent chair, coffee table, and desk with painting above.",
        "public_id": "019cfb37-800d-750a-8001-6eb4af71584b",
        "storage_key": "property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Kindred Hospital Northland",
      "seo_description": "Find apartments near Kindred Hospital Northland in Meadowbrook Heights at 97 at North Oak, offering comfort and convenience with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165581",
      "source": "generator",
      "page_item_url": "97-at-north-oak-apartments-near-happy-rock-park",
      "search_query": "apartments near Happy Rock Park Kansas City",
      "category": "Park",
      "h1_title": "Apartments Near Happy Rock Park, Kansas City",
      "h2_subtitle": "Discover the beauty of vibrant community living with apartments near Happy Rock Park in Kansas City at 97 at North Oak.",
      "page_copy": "Experience the perfect blend of nature and urban convenience at 97 at North Oak, located just a stone's throw from Happy Rock Park in Kansas City. Our expansive one, two, and three-bedroom apartments offer a delightful escape while keeping you close to the vibrant green spaces of the park. Whether you're an advocate for outdoor activities or simply enjoy a serene environment, you'll find our community offers the best of both worlds.<br><br>Conveniently positioned in Meadowbrook Heights, residents at 97 at North Oak enjoy a multitude of on-site amenities, such as a state-of-the-art fitness center, a sparkling swimming pool, and high-speed internet connectivity. Spend your weekends exploring the trails of Happy Rock Park or relax in our beautiful courtyard. With outstanding concierge service, our community serves as a welcoming retreat you’ll love to come home to.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, accent chair, coffee table, and desk with painting above.",
        "public_id": "019cfb37-800d-750a-8001-6eb4af71584b",
        "storage_key": "property/6767906449165581/019cfb37-800d-750a-8001-6eb4af71584b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Happy Rock Park, Kansas City",
      "seo_description": "Explore apartments near Happy Rock Park in Kansas City at 97 at North Oak, offering a mix of tranquility and modern amenities in Meadowbrook Heights.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5140"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-0CFC2E48PH"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18128850444"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/97-north-oak/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NZPZ4HHF"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165581/019d1bac-ba12-759c-83b8-5590e32e7948.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "ddecfcfb-3d18-4462-b9f7-caf9c6a49053"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "877-958-8469"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "63c834c249c9695d5d4b1990"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IldSemNUNGxjMFdrZkpONk0wbVVpcmc9PSIsInZhbHVlIjoiVDlyN2kvQmljQ0dueXBIUE9nZEpSdz09IiwibWFjIjoiMWQzOTI4OGY4M2YwMDY2NjRhY2MwYjQxYWIzNjE3YmFiMDljODRkNWQwNmYzMDc0ZTI5YWU5OGZjMWM0MjM2NCJ9"
    }
  ],
  "custom_qb_id": "5140",
  "custom_ga4_id": "G-0CFC2E48PH",
  "custom_repli_id": "18128850444",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/97-north-oak/register/",
  "custom_google_gtm_id": "GTM-NZPZ4HHF",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165581/019d1bac-ba12-759c-83b8-5590e32e7948.pdf",
  "custom_rentgrata_property_id": "ddecfcfb-3d18-4462-b9f7-caf9c6a49053",
  "custom_ppc_tracking_phone_number": "877-958-8469",
  "custom_residentboost_apartment_id": "63c834c249c9695d5d4b1990",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IldSemNUNGxjMFdrZkpONk0wbVVpcmc9PSIsInZhbHVlIjoiVDlyN2kvQmljQ0dueXBIUE9nZEpSdz09IiwibWFjIjoiMWQzOTI4OGY4M2YwMDY2NjRhY2MwYjQxYWIzNjE3YmFiMDljODRkNWQwNmYzMDc0ZTI5YWU5OGZjMWM0MjM2NCJ9"
};

export const generatedAt = '2026-08-27T21:39:55.617Z';
